import {
  getDiscountCodeTranslations,
  getTicketsV2Translations,
} from 'pages/ticketV2/common';
import { htmlParserOptions } from './constants';
import { getExhibitorsV2Translations } from 'pages/exhibitorsV2/common/translations';
import { getMatchMakingV2Translations } from 'pages/analyticsV2/common/translations';

const translations = {
  components: (intl) => ({
    countdownRedirect: {
      message: intl.formatMessage({
        description: 'countdown redirect message',
        defaultMessage:
          'You will be redirected to the previous page in ##COUNTDOWN##',
      }),
    },
  }),
  personalArea: (intl) => ({
    createProduct: {
      title: intl.formatMessage({
        description: 'page admin Title',
        defaultMessage: 'Create Product',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Personal Area',
      }),
    },
    cards: {
      view: intl.formatMessage({
        description: 'view button',
        defaultMessage: 'View/Edit',
      }),
      onlyView: intl.formatMessage({
        description: 'onlyView button',
        defaultMessage: 'Details',
      }),
      enter: intl.formatMessage({
        description: 'enter button',
        defaultMessage: 'Enter',
      }),
      remove: intl.formatMessage({
        description: 'remove button',
        defaultMessage: 'Remove',
      }),
      accept: intl.formatMessage({
        description: 'accept button',
        defaultMessage: 'Accept',
      }),
      decline: intl.formatMessage({
        description: 'decline button',
        defaultMessage: 'Decline',
      }),
      delete: intl.formatMessage({
        description: 'delete button',
        defaultMessage: 'Delete',
      }),
      participants: intl.formatMessage({
        description: 'participants',
        defaultMessage: 'Participants',
      }),
      details: intl.formatMessage({
        description: 'details',
        defaultMessage: 'View Details',
      }),
      showNotes: intl.formatMessage({
        description: 'show notes',
        defaultMessage: 'Show notes',
      }),
      brOver: intl.formatMessage({
        description: 'brOver',
        defaultMessage: 'This Session is over',
      }),
      brandLabel: intl.formatMessage({
        description: 'branLable',
        defaultMessage: 'Brand',
      }),
      noBrandLabel: intl.formatMessage({
        description: 'noBranLable',
        defaultMessage: 'Brand name not available',
      }),
      speakerRole: intl.formatMessage({
        description: 'speaker role tooltip',
        defaultMessage: 'Add a role for the Speaker',
      }),
      speakerDialog: {
        btn: intl.formatMessage({
          description: 'speaker dialog save',
          defaultMessage: 'Save',
        }),
        text: intl.formatMessage({
          description: 'speaker dialog text',
          defaultMessage: 'Add a role for the Speaker',
        }),
      },
      types: {
        chat_session: intl.formatMessage({
          description: 'Chat Session type',
          defaultMessage: 'Live Chat Session',
        }),
        breakout_session: intl.formatMessage({
          description: 'Breakout Room session type',
          defaultMessage: 'Breakout Room',
        }),
      },
    },
    adminPage: {
      title: intl.formatMessage({
        description: 'page admin Title',
        defaultMessage: 'Sessions List',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Personal Area',
      }),
      noBrBrandAvailable: intl.formatMessage({
        description: 'no br available',
        defaultMessage: "There aren't sessions available",
      }),
      numberBr: intl.formatMessage({
        description: 'number br available',
        defaultMessage: 'Total number of Sessions',
      }),
    },
    brandPage: {
      title: intl.formatMessage({
        description: 'page brand Title',
        defaultMessage: 'My Sessions',
      }),
      description: intl.formatMessage({
        description: 'page brand description',
        defaultMessage:
          'At most three Breakout Rooms can be created at any one time.',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Personal Area',
      }),
      noBrBrandAvailable: intl.formatMessage({
        description: 'no br available',
        defaultMessage: "There aren't sessions available",
      }),
      buttons: {
        createBr: intl.formatMessage({
          description: 'create br button',
          defaultMessage: 'Create Session',
        }),
      },
    },
    userPage: {
      title: intl.formatMessage({
        description: 'page user Title',
        defaultMessage: 'Virtual Agenda',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Personal Area',
      }),
      noBrAvailable: intl.formatMessage({
        description: 'no br available',
        defaultMessage: "There aren't sessions available",
      }),
      acceptDialog: {
        title: intl.formatMessage({
          description: 'accept dialog title',
          defaultMessage: 'Thank you for accepting!',
        }),
        agree: intl.formatMessage({
          description: 'understood button',
          defaultMessage: 'I got it',
        }),
        body: intl.formatMessage({
          description: 'accept dialog body',
          defaultMessage:
            'Thank you for having responded to the invitation. You will shortly receive an email with the appointment link. The link will be valid from the day of the appointment.',
        }),
      },
      emailDialog: {
        title: intl.formatMessage({
          description: 'email dialog title',
          defaultMessage: 'Unrecognised user',
        }),
        agree: intl.formatMessage({
          description: 'email understood button',
          defaultMessage: 'I got it',
        }),
        body: intl.formatMessage({
          description: 'email accept dialog body',
          defaultMessage: `You are not authorised to access this content. Sign in with the same email address you used to receive the invitation.`,
        }),
      },
      maxBrcountDialog: {
        title: intl.formatMessage({
          description: 'maxBrcountDialog dialog title',
          defaultMessage: 'Unable to create a session',
        }),
        agree: intl.formatMessage({
          description: 'maxBrcountDialog understood button',
          defaultMessage: 'I got it',
        }),
        body: intl.formatMessage({
          description: 'maxBrcountDialog accept dialog body',
          defaultMessage: `You have reached the limit number of sessions, in order to proceed with a new reservation you must first remove an existing one.`,
        }),
      },
      declineDialog: {
        title: intl.formatMessage({
          description: 'decline dialog title',
          defaultMessage: 'Decline Invitation',
        }),
        send: intl.formatMessage({
          description: 'send button',
          defaultMessage: 'Send',
        }),
        subtitle: intl.formatMessage({
          description: 'decline dialog subtitle',
          defaultMessage: 'Please tell us the reason of the decline',
        }),
        headLabel: intl.formatMessage({
          description: 'decline dialog head label',
          defaultMessage: 'Reason of the decline*',
        }),
        additionalNotes: intl.formatMessage({
          description: 'decline dialog additonal notes',
          defaultMessage: 'Write some additional notes…',
        }),
        checkboxes: {
          cannot: intl.formatMessage({
            description: 'cannot button',
            defaultMessage: "I can't participate",
          }),
          notInterested: intl.formatMessage({
            description: 'notInterested button',
            defaultMessage: "I'm not interested.",
          }),
          newProposal: intl.formatMessage({
            description: 'newProposal button',
            defaultMessage:
              'I would like to receive a different appointment proposal',
          }),
          other: intl.formatMessage({
            description: 'other',
            defaultMessage: 'Other',
          }),
        },
      },
    },
  }),
  detailsPage: (intl) => ({
    summary: intl.formatMessage({
      description: 'summary text detail and summary on ical',
      defaultMessage:
        'You are invited at the appointment with the Brand ##BRAND## on date ##DAY## from ##START## to ##END##',
    }),
    summaryChat: intl.formatMessage({
      description: 'summary text detail and summary on ical',
      defaultMessage:
        'You are invited at the Live Chat Session with ##BRAND## from ##START## to ##END##',
    }),
    enterTooltip: intl.formatMessage({
      description: 'enter button tooltip',
      defaultMessage:
        'This link will be active between ##START## and ##END## on ##DATE##',
    }),
    enterChatTooltip: intl.formatMessage({
      description: 'enter button tooltip',
      defaultMessage: 'This link will be active between ##START## and ##END##',
    }),
    icalName: intl.formatMessage({
      description: 'ical name',
      defaultMessage: 'You are invited at the appointment with the Brand',
    }),
    subtitle: intl.formatMessage({
      description: 'page subtitle',
      defaultMessage: 'Personal Area/My Virtual Meeting Agenda',
    }),
    temporaryBody: intl.formatMessage({
      description: 'page temporaryBody',
      defaultMessage:
        'The first Break Out Room of the new digital platform of Salone del Mobile.Milano, dedicated to supersalone. An opportunity to talk directly with the co-curators of the September special project.',
    }),
    buttons: {
      calendar: intl.formatMessage({
        description: 'calendar button',
        defaultMessage: 'Add to calendar',
      }),
      decline: intl.formatMessage({
        description: 'decline button',
        defaultMessage: 'Decline',
      }),
      canceled: intl.formatMessage({
        description: 'canceled button',
        defaultMessage: 'Canceled',
      }),
      rejected: intl.formatMessage({
        description: 'rejected button',
        defaultMessage: 'Rejected',
      }),
      accept: intl.formatMessage({
        description: 'accept button',
        defaultMessage: 'Accept',
      }),
      enter: intl.formatMessage({
        description: 'enter button',
        defaultMessage: 'Enter',
      }),
      back: intl.formatMessage({
        description: 'back button',
        defaultMessage: 'Back',
      }),
    },
  }),
  breakoutRoomForm: (intl) => ({
    title: intl.formatMessage({
      description: 'page brForm Title',
      defaultMessage: 'Breakout Room',
    }),
    subtitle: intl.formatMessage({
      description: 'page subtitle',
      defaultMessage: 'Settings',
    }),
    invite: intl.formatMessage({
      description: 'invite button',
      defaultMessage: 'Invite Users',
    }),
    inviteXsDown: intl.formatMessage({
      description: 'inviteXs button',
      defaultMessage: 'Invite',
    }),
    deleteBr: intl.formatMessage({
      description: 'deleteBr button',
      defaultMessage: 'Delete Session',
    }),
    copyToClipboard: intl.formatMessage({
      description: 'Copy Link button',
      defaultMessage: 'Copy Link',
    }),
    copiedToClipboard: intl.formatMessage({
      description: 'Copy Link button',
      defaultMessage: 'Copied',
    }),
    back: intl.formatMessage({
      description: 'back button',
      defaultMessage: 'Back',
    }),
    save: intl.formatMessage({
      description: 'save button',
      defaultMessage: 'Save',
    }),
    updateSaveTooltip: intl.formatMessage({
      description: 'save button updateSaveTooltip',
      defaultMessage: 'Save session changes',
    }),
    updateSaveTooltipDisabled: intl.formatMessage({
      description: 'save button updateSaveTooltipDisabled',
      defaultMessage:
        'To change session settings, please delete all invitations',
    }),
    createSaveTooltip: intl.formatMessage({
      description: 'save button createSaveTooltip',
      defaultMessage: 'Create new session',
    }),
    addSpeaker: intl.formatMessage({
      description: 'add speaker button',
      defaultMessage: 'Add Speaker',
    }),
    speakers: {
      givenName: {
        label: intl.formatMessage({
          description: 'firstName speaker textfield',
          defaultMessage: 'Firstname',
        }),
        error: intl.formatMessage({
          description: 'firstName required err',
          defaultMessage: 'Firstname is required',
        }),
      },
      familyName: {
        label: intl.formatMessage({
          description: 'lastName speaker textfield',
          defaultMessage: 'Lastname',
        }),
        error: intl.formatMessage({
          description: 'lastname required err',
          defaultMessage: 'Lastname is required',
        }),
      },
      coverImage: intl.formatMessage({
        description: 'coverImage speaker textfield',
        defaultMessage: 'Image',
      }),
      jobTitle: intl.formatMessage({
        description: 'jobTitle speaker textfield',
        defaultMessage: 'Role',
      }),
    },
    deleteDialog: {
      title: intl.formatMessage({
        description: 'delete dialog title',
        defaultMessage: 'Delete invitation',
      }),
      message: intl.formatMessage({
        description: 'delete dialog message',
        defaultMessage: 'This user will be permanently deleted',
      }),
      agreeText: intl.formatMessage({
        description: 'delete dialog agree text',
        defaultMessage: 'Confirm delete',
      }),
    },
    bookedDialog: {
      title: intl.formatMessage({
        description: 'booked dialog title',
        defaultMessage: 'Slot not available',
      }),
      agree: intl.formatMessage({
        description: 'booked understood button',
        defaultMessage: 'I got it',
      }),
      body: intl.formatMessage({
        description: 'booked accept dialog body',
        defaultMessage: `This time slot has already been booked, please select a different date or time.`,
      }),
    },
    noteDialog: {
      title: intl.formatMessage({
        description: 'note dialog title',
        defaultMessage: 'Rejection note',
      }),
    },
    fields: {
      customError: intl.formatMessage({
        description: 'customErrorLabel',
        defaultMessage:
          'The Breakout Room should start after 9:00 and finish before 18:00, lasting for a maximum of 1 hour',
      }),
      topic: {
        label: intl.formatMessage({
          description: 'topicLabel',
          defaultMessage: 'Topic',
        }),
        error: intl.formatMessage({
          description: 'topicLabelError',
          defaultMessage: 'Topic is required',
        }),
      },
      date: {
        label: intl.formatMessage({
          description: 'dayLabel',
          defaultMessage: 'Day',
        }),
        error: intl.formatMessage({
          description: 'dayLabelError',
          defaultMessage: 'Date is required',
        }),
      },
      start: {
        label: intl.formatMessage({
          description: 'startLabel',
          defaultMessage: 'Starting at',
        }),
        error: intl.formatMessage({
          description: 'startLabelError',
          defaultMessage: 'Start time is required',
        }),
      },
      end: {
        label: intl.formatMessage({
          description: 'endLabel',
          defaultMessage: 'Ending at',
        }),
        error: intl.formatMessage({
          description: 'endLabelError',
          defaultMessage: 'End time is required',
        }),
      },
      startDateTime: {
        label: intl.formatMessage({
          description: 'startLabel',
          defaultMessage: 'Starting at',
        }),
        error: intl.formatMessage({
          description: 'startLabelError',
          defaultMessage: 'Start date and time are required',
        }),
      },
      endDateTime: {
        label: intl.formatMessage({
          description: 'endLabel',
          defaultMessage: 'Ending at',
        }),
        error: intl.formatMessage({
          description: 'endLabelError',
          defaultMessage: 'End date and time are required',
        }),
      },
      sessionType: {
        label: intl.formatMessage({
          description: 'sessionTypeLabel',
          defaultMessage: 'Select Session Type',
        }),
        error: intl.formatMessage({
          description: 'endLabelError',
          defaultMessage: 'Session Type is required',
        }),
        disabledLabel: intl.formatMessage({
          description: 'sessionTypeDisableLabel',
          defaultMessage: 'Type',
        }),
        values: {
          breakout_session: intl.formatMessage({
            description: 'brsessionLabel',
            defaultMessage: 'Breakout Room Session',
          }),
          chat_session: intl.formatMessage({
            description: 'chatsessionLabel',
            defaultMessage: 'Live Chat Session',
          }),
        },
      },
      description: {
        label: intl.formatMessage({
          description: 'description label',
          defaultMessage: 'Write the descriptive text for the Session',
        }),
        error: intl.formatMessage({
          description: 'descriptionError',
          defaultMessage: 'Description is required',
        }),
      },

      coverImage: {
        title: intl.formatMessage({
          description: 'imageUploader title',
          defaultMessage: 'Cover Image',
        }),
        subtitle: intl.formatMessage({
          description: 'imageUploader subtitle',
          defaultMessage:
            '(Accepted files: jpg, jpeg, png. Maximum size allowed: 300 Kb)',
        }),
        error: intl.formatMessage({
          description: 'imageError',
          defaultMessage: 'Image is required',
        }),
      },
    },
    invitationList: {
      tabs: {
        invited: intl.formatMessage({
          description: 'invitedTabLabel',
          defaultMessage: 'Invited',
        }),
        attending: intl.formatMessage({
          description: 'attendingTabLabel',
          defaultMessage: 'Attending',
        }),
        withoutTicket: intl.formatMessage({
          description: 'notInvitedTabLabel',
          defaultMessage: 'Participants',
        }),
      },
    },
  }),
  handleInvitations: (intl) => ({
    language: {
      values: {
        it_IT: intl.formatMessage({
          description: 'languageItalianLabel',
          defaultMessage: 'Italian',
        }),
        en_EN: intl.formatMessage({
          description: 'languageEnglishLabel',
          defaultMessage: 'English',
        }),
      },
      label: intl.formatMessage({
        description: 'communicationLabel',
        defaultMessage: 'Select communication language',
      }),
    },
    pageInvite: {
      public: {
        text: intl.formatMessage({
          description: 'page invite public text',
          defaultMessage:
            'Share the link directly with guests you want to invite to the appointment. To register for the appointment, guests must register their names on the platform',
        }),
        link: intl.formatMessage({
          description: 'page invite public link',
          defaultMessage: 'Create the link',
        }),
        warning: intl.formatMessage({
          description: 'page invite public warning',
          defaultMessage: 'Please note',
        }),
        confirm: intl.formatMessage({
          description: 'page invite public confirm',
          defaultMessage: 'Confirm',
        }),
        sorry: intl.formatMessage({
          description: 'page invite public sorry',
          defaultMessage: 'We’re sorry!',
        }),
        sorryText: intl.formatMessage({
          description: 'page invite public sorry text',
          defaultMessage:
            'No more places available for this session. We’re sorry for the inconvenience, but the session is complete',
        }),
        dialog: {
          title: intl.formatMessage({
            description: 'page invite public dialog title',
            defaultMessage: 'Participation Confirmed',
          }),
          agree: intl.formatMessage({
            description: 'page invite public dialog agree',
            defaultMessage: 'Agenda',
          }),
          body: intl.formatMessage({
            description: 'page invite public dialog body',
            defaultMessage: 'Go to your agenda to view all your appointments',
          }),
        },
        limited: intl.formatMessage({
          description: 'page invite public limited',
          defaultMessage:
            'Places are limited. Confirm your presence at once to be sure to be able to join in the session',
        }),
        warningText: intl.formatMessage({
          description: 'page invite public warningText',
          defaultMessage:
            'Breakout Rooms have a limit of 49 guests. A place will be guaranteed to everyone directly invited on this page. The others, invited by sharing the link, can register depending on availability ',
        }),
      },
      title: intl.formatMessage({
        description: 'page invite Title',
        defaultMessage: 'Meet The Brand',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Invite participants',
      }),
      generalText: intl.formatMessage({
        description: 'page general text',
        defaultMessage:
          'Insert users’ emails to send a message notifying them of the appointment.',
      }),
      emailListInput: {
        label: intl.formatMessage({
          description: 'email list input label',
          defaultMessage:
            'Insert users’ emails separate from ; sample@gmail.com;',
        }),
      },
      emailTextInput: {
        label: intl.formatMessage({
          description: 'email text input label',
          defaultMessage: 'Write the text of the email',
        }),
      },
      leftButton: intl.formatMessage({
        description: 'left button text',
        defaultMessage: 'Back',
      }),
      rightButton: intl.formatMessage({
        description: 'right button text',
        defaultMessage: 'Save',
      }),
      errors: {
        tooMuchPax: intl.formatMessage({
          description: 'too much user invited',
          defaultMessage: 'You have exceeded the limit of allowed users',
        }),
        invalidEmail: intl.formatMessage({
          description: 'invalidEmail',
          defaultMessage: 'is not a valid email address',
        }),
        doubleEmail: intl.formatMessage({
          description: 'doubleEmail',
          defaultMessage: 'has already been entered',
        }),
        invitedEmail: intl.formatMessage({
          description: 'invited',
          defaultMessage: 'has already been invited',
        }),
      },
    },
    pageDeleteBr: {
      title: intl.formatMessage({
        description: 'page invite Title',
        defaultMessage: 'Meet The Brand',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Delete Session',
      }),
      generalText: intl.formatMessage({
        description: 'page general text',
        defaultMessage:
          'All participants will be removed. It is possible to customize the deleting event notification message.',
      }),
      emptyText: intl.formatMessage({
        description: 'page general text',
        defaultMessage:
          'Clicking on delete button will definitely delete this Session.',
      }),
      emailTextInput: {
        label: intl.formatMessage({
          description: 'email text input label',
          defaultMessage: 'Write the text of the email',
        }),
      },
      leftButton: intl.formatMessage({
        description: 'left button text',
        defaultMessage: 'Back',
      }),
      rightButton: intl.formatMessage({
        description: 'right button text',
        defaultMessage: 'Delete',
      }),
    },

    pageCancelUser: {
      title: intl.formatMessage({
        description: 'page invite Title',
        defaultMessage: 'Meet The Brand',
      }),
      subtitle: intl.formatMessage({
        description: 'page subtitle',
        defaultMessage: 'Remove Participant',
      }),
      generalText: intl.formatMessage({
        description: 'page general text',
        defaultMessage:
          'The selected user will be removed. It is possible to customize the deleting invitation notification message.',
      }),
      emailTextInput: {
        label: intl.formatMessage({
          description: 'email text input label',
          defaultMessage: 'Write the text of the email',
        }),
      },
      leftButton: intl.formatMessage({
        description: 'left button text',
        defaultMessage: 'Back',
      }),
      rightButton: intl.formatMessage({
        description: 'right button text',
        defaultMessage: 'Remove',
      }),
    },
  }),
  exhibitorBookmark: (intl) => ({
    error: intl.formatMessage({
      description: 'exhibitorBookmark errors required',
      defaultMessage: 'Field Required',
    }),
    labels: {
      toVisit: intl.formatMessage({
        description: 'exhibitorBookmark labels toVisit',
        defaultMessage: 'To be visited',
      }),
      visited: intl.formatMessage({
        description: 'exhibitorBookmark labels visited',
        defaultMessage: 'Visited',
      }),
      visitedExhibitors: intl.formatMessage({
        description: 'exhibitorBookmark labels visitedExhibitors',
        defaultMessage: 'Visited Exhibitors',
      }),
      edit: intl.formatMessage({
        description: 'exhibitorBookmark labels edit',
        defaultMessage: 'Edit',
      }),
      close: intl.formatMessage({
        description: 'exhibitorBookmark labels close',
        defaultMessage: 'Close',
      }),
      all: intl.formatMessage({
        description: 'exhibitorBookmark labels all',
        defaultMessage: 'All selected exhibitors',
      }),
      seeOnMap: intl.formatMessage({
        description: 'exhibitorBookmark labels seeOnMap',
        defaultMessage: 'See on map',
      }),
    },
    buttons: {
      createFolder: intl.formatMessage({
        description: 'exhibitorBookmark buttons createFolder',
        defaultMessage: 'Create new folder',
      }),
      move: intl.formatMessage({
        description: 'exhibitorBookmark buttons move',
        defaultMessage: 'Move',
      }),
      remove: intl.formatMessage({
        description: 'exhibitorBookmark buttons remove',
        defaultMessage: 'Delete from Plan your visit section',
      }),
      removeFromFolder: intl.formatMessage({
        description: 'exhibitorBookmark buttons removeFromFolder',
        defaultMessage: 'Remove from folder',
      }),
      cancel: intl.formatMessage({
        description: 'exhibitorBookmark buttons cancel',
        defaultMessage: 'Cancel',
      }),
      confirm: intl.formatMessage({
        description: 'exhibitorBookmark buttons confirm',
        defaultMessage: 'Confirm',
      }),
      renameFolder: intl.formatMessage({
        description: 'exhibitorBookmark buttons renameFolder',
        defaultMessage: 'Rename folder',
      }),
      deleteFolder: intl.formatMessage({
        description: 'exhibitorBookmark buttons deleteFolder',
        defaultMessage: 'Delete folder',
      }),
    },
    dialogs: {
      createFolder: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark dialogs createFolder title',
          defaultMessage: 'Create a new folder',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark dialogs createFolder subTitle',
          defaultMessage: 'Enter the name',
        }),
        textfield: intl.formatMessage({
          description: 'exhibitorBookmark dialogs createFolder textfield',
          defaultMessage: 'Folder name',
        }),
        defaultValue: intl.formatMessage({
          description: 'exhibitorBookmark dialogs createFolder defaultValue',
          defaultMessage: 'New Folder',
        }),
      },
      editFolder: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark dialogs editFolder title',
          defaultMessage: 'Edit folder name',
        }),
      },
      deleteFolder: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark dialogs deleteFolder title',
          defaultMessage: 'Do you want to delete the folder?',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark dialogs deleteFolder subTitle',
          defaultMessage:
            'When you delete this folder, the items you visit will remain saved in the All collection.',
        }),
      },
      remove: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark dialogs remove title',
          defaultMessage: 'Do you want to remove from Plan your visit?',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark dialogs remove subTitle',
          defaultMessage:
            'The items to visit will be removed by Plan your visit.',
        }),
      },
      removePostEvent: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark dialogs removePostEvent title',
          defaultMessage: 'Do you want to remove exhibitors from the list?',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark dialogs removePostEvent subTitle',
          defaultMessage:
            "If you remove an exhibitor from the list, you will not be able to find them again. At the next Salone del Mobile, you will be able to add them to your 'To Visit' list again.",
        }),
        confirm: intl.formatMessage({
          description: 'exhibitorBookmark dialogs removePostEvent confirm',
          defaultMessage: 'Confirm your request',
        }),
      },
      removeFromFolder: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark dialogs removeFromFolder title',
          defaultMessage: 'Do you want to remove from folder?',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark dialogs removeFromFolder subTitle',
          defaultMessage:
            'The items you visit will remain saved in the All collection.',
        }),
      },
    },
    tabs: {
      list: intl.formatMessage({
        description: 'exhibitorBookmark labels exhibitors',
        defaultMessage: 'Exhibitors',
      }),
      manage: intl.formatMessage({
        description: 'exhibitorBookmark labels manage',
        defaultMessage: 'To visit 2024',
      }),
    },
    manage: {
      empty: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark manage empty title',
          defaultMessage: 'You have not yet chosen any exhibitors to visit',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark manage empty subTitle',
          defaultMessage:
            'Plan your visit: add the companies you want to visit from the Exhibitor list. Once added, you can organise them into folders.',
        }),
        btn: intl.formatMessage({
          description: 'exhibitorBookmark manage empty btn',
          defaultMessage: 'Go to the Exhibitor list',
        }),
      },
    },
    folders: {
      empty: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark folders empty title',
          defaultMessage: 'You have not added any exhibitors to this folder',
        }),
        subTitle: intl.formatMessage({
          description: 'exhibitorBookmark folders empty subTitle',
          defaultMessage:
            'From the “All selected exhibitors” section in “Plan your visit”, you can view the exhibitors that you have marked as “To be visited” and reorganize them into folders.',
        }),
        btn: intl.formatMessage({
          description: 'exhibitorBookmark folders empty btn',
          defaultMessage: 'See Exhibitors to Visit',
        }),
      },
      labelScheduled: intl.formatMessage({
        description: 'exhibitorBookmark folders labelScheduled',
        defaultMessage: 'Scheduled',
      }),
      labelExhibitors: intl.formatMessage({
        description: 'exhibitorBookmark folders labelExhibitors',
        defaultMessage: 'Exhibitors',
      }),
      back: intl.formatMessage({
        description: 'exhibitorBookmark folders move back',
        defaultMessage: 'Back',
      }),
      move: {
        title: intl.formatMessage({
          description: 'exhibitorBookmark folders move page title',
          defaultMessage: 'Move to folder',
        }),
        saveTitle: intl.formatMessage({
          description: 'exhibitorBookmark folders save page title',
          defaultMessage: 'Save to folder',
        }),
        subtitle: intl.formatMessage({
          description: 'exhibitorBookmark folders move page title',
          defaultMessage: 'Plan your visit',
        }),
        buttons: {
          save: intl.formatMessage({
            description: 'exhibitorBookmark folders move page btns save',
            defaultMessage: 'Save',
          }),
          cancel: intl.formatMessage({
            description: 'exhibitorBookmark folders move page btns save',
            defaultMessage: 'Cancel',
          }),
        },
      },
    },
  }),
  ExhibitorsList: (intl) => ({
    map: {
      title: intl.formatMessage({
        description: 'ExhibitorsList map title',
        defaultMessage: 'Exhibitors',
      }),
      view: intl.formatMessage({
        description: 'ExhibitorsList view title',
        defaultMessage: 'View',
      }),
      stand: intl.formatMessage({
        description: 'ExhibitorsList stand title',
        defaultMessage: 'Stand',
      }),
      pavillion: intl.formatMessage({
        description: 'ExhibitorsList view pavillion',
        defaultMessage: 'Pavillion',
      }),
      buttons: {
        previous: intl.formatMessage({
          description: ' ExhibitorsList view pavillion prevoius btn',
          defaultMessage: 'Previous',
        }),
        next: intl.formatMessage({
          description: ' ExhibitorsList view pavillion next btn',
          defaultMessage: 'Next',
        }),
      },
    },
    page: {
      title: intl.formatMessage({
        description: 'ExhibitorsList title',
        defaultMessage: 'Salone del Mobile.Milano 2025 Exhibitor List',
      }),
      subtitleDescription: intl.formatMessage({
        description: 'ExhibitorsList title',
        defaultMessage:
          'All the exhibitors present at the last edition of the Salone del Mobile.Milano from 8 to 13 April 2025.',
      }),
      titleBiennali: intl.formatMessage({
        description: 'Biennali title',
        defaultMessage:
          'Eurocucina and International Bathroom Exhibition 2024 exhibitor list',
      }),
      subtitleDescriptionBiennali: intl.formatMessage({
        description: 'Biennali subtitle',
        defaultMessage:
          'Exhibitors of the latest edition of EuroCucina and International Bathroom Exhibition from 16 to 21 April 2024.',
      }),
      subtitleDate: intl.formatMessage({
        description: 'ExhibitorsList subtitle',
        defaultMessage: 'List being updated, date of last update:',
      }),
      notAvailable: intl.formatMessage({
        description: 'Exhibition not available title',
        defaultMessage: 'Exhibition not available',
      }),
      notAvailableEx: intl.formatMessage({
        description: 'Exhibition not available title',
        defaultMessage: 'There are no results matching the search criteria',
      }),
      buttons: {
        previous: intl.formatMessage({
          description: 'prevoius btn',
          defaultMessage: 'Previous',
        }),
        next: intl.formatMessage({
          description: 'next btn',
          defaultMessage: 'Next',
        }),
      },
      selectAll: intl.formatMessage({
        description: 'selectAll btn',
        defaultMessage: 'Check All',
      }),
      deselectAll: intl.formatMessage({
        description: 'deselectAll btn',
        defaultMessage: 'Uncheck All',
      }),
      notLogged: {
        title: intl.formatMessage({
          description: 'Exhibition notLogged title',
          defaultMessage: 'Restricted area',
        }),
        body: intl.formatMessage({
          description: 'Exhibition notLogged body',
          defaultMessage:
            'Register or log in to take advantage of this feature',
        }),
        login: intl.formatMessage({
          description: 'Exhibition notLogged login',
          defaultMessage: 'Login',
        }),
      },
    },
    detailPage: {
      contact: intl.formatMessage({
        description: 'contact btn',
        defaultMessage: 'Contact',
      }),
      booking: intl.formatMessage({
        description: 'booking btn',
        defaultMessage: 'Booking',
      }),
      categories: intl.formatMessage({
        description: 'categories title',
        defaultMessage: 'Categories',
      }),
      products: intl.formatMessage({
        description: 'products title',
        defaultMessage: 'Products',
      }),
      visit: intl.formatMessage({
        description: 'visit btn',
        defaultMessage: 'Visit brand page',
      }),
      description: intl.formatMessage({
        description: 'description txt',
        defaultMessage: 'Find out more about our company and our history.',
      }),
      back: intl.formatMessage({
        description: 'back btn',
        defaultMessage: 'Back',
      }),
      notAvailable: intl.formatMessage({
        description: 'notAvailable',
        defaultMessage: 'Not Available',
      }),
      dialog: {
        title: intl.formatMessage({
          description: 'dialog title',
          defaultMessage: 'Get in touch with',
        }),
        send: intl.formatMessage({
          description: 'send btn',
          defaultMessage: 'Send',
        }),
      },
    },
    filters: {
      title: intl.formatMessage({
        description: 'ExhibitorsList filters title',
        defaultMessage: 'Filters',
      }),
      reset: intl.formatMessage({
        description: 'ExhibitorsList filters reset',
        defaultMessage: 'Reset Filters',
      }),
      searchLabel: intl.formatMessage({
        description: 'ExhibitorsList filters search label',
        defaultMessage: 'Search brand',
      }),
      filterItems: {
        alphabet: intl.formatMessage({
          description: 'ExhibitorsList filters Alphabetical label',
          defaultMessage: 'Alphabetical',
        }),
        hall: intl.formatMessage({
          description: 'ExhibitorsList filters Hall label',
          defaultMessage: 'Hall',
        }),
        exhibition: intl.formatMessage({
          description: 'ExhibitorsList filters Exhibition label',
          defaultMessage: 'Exhibition',
        }),
        hallNotAvailable: intl.formatMessage({
          description: 'ExhibitorsList filters Hall not available label',
          defaultMessage: 'n.a.',
        }),
        country: intl.formatMessage({
          description: 'ExhibitorsList filters Country label',
          defaultMessage: 'Country',
        }),
        itineraries: intl.formatMessage({
          description: 'ExhibitorsList filters itineraries label',
          defaultMessage: 'Thematic paths',
        }),
        years: intl.formatMessage({
          description: 'ExhibitorsList filters Year label',
          defaultMessage: 'Year',
        }),
        categories: intl.formatMessage({
          description: 'ExhibitorsList filters Categories label',
          defaultMessage: 'Categories',
        }),
        products: intl.formatMessage({
          description: 'ExhibitorsList filters Products label',
          defaultMessage: 'Products',
        }),
      },
    },
  }),
  Analytics: (intl) => ({
    page: {
      title: intl.formatMessage({
        description: 'Analytics title',
        defaultMessage: 'Analytics',
      }),
      download: {
        title: intl.formatMessage({
          description: 'download title',
          defaultMessage: 'Documents',
        }),
        description: intl.formatMessage({
          description: 'brand visitors description',
          defaultMessage: 'Here you can find the guide for this area',
        }),
        btn: intl.formatMessage({
          description: 'download title',
          defaultMessage: 'Analytics Guidelines',
        }),
      },
      visitors: {
        title: intl.formatMessage({
          description: 'visitors title',
          defaultMessage: 'Brand Page visitors',
        }),
        description: intl.formatMessage({
          description: 'brand visitors description',
          defaultMessage:
            'Number of total and logged-in users who visited the brand page in the selected period',
        }),
        total: intl.formatMessage({
          description: 'Total visitors',
          defaultMessage: 'Total Number of Users',
        }),
        logged: intl.formatMessage({
          description: 'Logged visitors',
          defaultMessage: 'Logged in Users among them',
        }),
      },
      visitors_product: {
        title: intl.formatMessage({
          description: 'visitors product_title',
          defaultMessage: 'Product page visitors',
        }),
        description: intl.formatMessage({
          description: 'product visitors description',
          defaultMessage:
            'Number of total and logged-in users who visited at least one brand product detail pages in the selected period',
        }),
        total: intl.formatMessage({
          description: 'Total visitors',
          defaultMessage: 'Total Number of Users',
        }),
        logged: intl.formatMessage({
          description: 'Logged visitors',
          defaultMessage: 'Logged in Users among them',
        }),
      },
      fair: {
        title: intl.formatMessage({
          description: 'fair big title',
          defaultMessage: "Fair's Analytics",
        }),
        errors: {
          fetchingReports: intl.formatMessage({
            description: 'fair error fetching reports',
            defaultMessage:
              'An error occured getting the report, please try again',
          }),
        },
        waitText: intl.formatMessage({
          description: 'fair wait text',
          defaultMessage: 'Please wait a few minutes before download the file',
        }),
        notAvailable: intl.formatMessage({
          description: 'counters not available',
          defaultMessage: 'N.A.',
        }),
        dialog: {
          btn: intl.formatMessage({
            description: 'fair dialog btn text',
            defaultMessage: 'Got it',
          }),
          success: {
            createReport: intl.formatMessage({
              description: 'fair dialog create report success',
              defaultMessage: 'Request created successfully',
            }),
          },
          error: {
            createReport: intl.formatMessage({
              description: 'fair dialog create report error',
              defaultMessage: 'The file cannot be generated',
            }),
            downloadReport: intl.formatMessage({
              description: 'fair dialog download report error',
              defaultMessage: 'File not available',
            }),
            download: intl.formatMessage({
              description: 'fair dialog download report sub error',
              defaultMessage:
                'If you have just requested generation wait a few minutes, otherwise click on generate csv.',
            }),
            downloadUpdate: intl.formatMessage({
              description: 'fair dialog download report sub error',
              defaultMessage:
                'If you have just requested generation wait a few minutes, otherwise click on Update .csv.',
            }),
          },
        },
        left: {
          title: intl.formatMessage({
            description: 'fair left title',
            defaultMessage: 'Stand counter',
          }),
          description: intl.formatMessage({
            description: 'fair left subtitle',
            defaultMessage:
              'In this section it is possible to download a csv with the list of all the scans made through the stand counter feature. These scans are the ones not associated with customer data, otherwise available in the matchmaking csv.',
          }),
          columnLeft: intl.formatMessage({
            description: 'fair left left column',
            defaultMessage: 'Total Scans',
          }),
          columnRight: intl.formatMessage({
            description: 'fair left right column',
            defaultMessage: 'Today Scans',
          }),
          btn: intl.formatMessage({
            description: 'fair left btn',
            defaultMessage: 'Generate csv',
          }),
          btnDownload: intl.formatMessage({
            description: 'fair left btn dowload',
            defaultMessage: 'CSV Tickets Scans',
          }),
        },
        right: {
          title: intl.formatMessage({
            description: 'fair right title',
            defaultMessage: 'Matchmaking',
          }),
          description: intl.formatMessage({
            description: 'fair right subtitle',
            defaultMessage:
              'In this section it is possible to download a csv with the list of all the scans made through the matchmaking feature.',
          }),
          columnLeft: intl.formatMessage({
            description: 'fair right left column',
            defaultMessage: 'Total matchmakes',
          }),
          columnRight: intl.formatMessage({
            description: 'fair right right column',
            defaultMessage: 'Today matchmakes',
          }),
          btn: intl.formatMessage({
            description: 'fair right btn',
            defaultMessage: 'Generate csv',
          }),
          btnDownload: intl.formatMessage({
            description: 'fair right btn dowload',
            defaultMessage: 'CSV Matchmaking',
          }),
        },
      },
      geography: intl.formatMessage({
        description: 'geography subtitle',
        defaultMessage: 'Geographical origin',
      }),
      geographyDescription: intl.formatMessage({
        description: 'geography description',
        defaultMessage:
          'Percentage of brand page logged-in visitors grouped by nationality',
      }),
      user: intl.formatMessage({
        description: 'user subtitle',
        defaultMessage: 'User Type',
      }),
      userDescription: intl.formatMessage({
        description: 'user subtitle',
        defaultMessage:
          'Percentage of brand page logged-in visitors grouped by user typology',
      }),
      sessionOperators: intl.formatMessage({
        description: 'sector operators subtitle',
        defaultMessage: 'Operators in the Sector',
      }),
      sessionOperatorsDescription: intl.formatMessage({
        description: 'sector operators subtitle',
        defaultMessage:
          'Percentage of brand page logged-in visitors grouped by user sub-typology',
      }),
      session: {
        title: intl.formatMessage({
          description: 'sessions subtitle',
          defaultMessage: 'Sessions',
        }),
        description: intl.formatMessage({
          description: 'sessions description',
          defaultMessage:
            'Average number of browsing sessions and live events attended by unique logged-in visitors who viewed the brand page at least once',
        }),
        average: intl.formatMessage({
          description: 'average index',
          defaultMessage: 'Average Nb. Of Sessions',
        }),
      },
      interbrand: {
        title: intl.formatMessage({
          description: 'interactions subtitle',
          defaultMessage: 'Interactions with the Brand Page',
        }),
        description: intl.formatMessage({
          description: 'interactions subtitle',
          defaultMessage:
            "Detail of interactions with the brand page and with the brand's product pages. While the number of users who have contacted the brand takes into account both logged-in and non-logged-in users, the other KPIs refer exclusively to logged-in users",
        }),
      },
      country: intl.formatMessage({
        description: 'country subtitle',
        defaultMessage: 'Country',
      }),
      perceUser: intl.formatMessage({
        description: 'perce subtitle',
        defaultMessage: 'Percentage of Users',
      }),
      fetchingError: intl.formatMessage({
        description: 'fetchingError message',
        defaultMessage: 'There are no data available for this brand',
      }),
    },
    params: {
      VISITATORI_LOGGATI_TOTALI_BRAND: intl.formatMessage({
        description: 'VISITATORI_LOGGATI_TOTALI_BRAND',
        defaultMessage: 'Total signed in brand visitors',
      }),
      VISITATORI_LOGGATI_TOTALI_PRODOTTO: intl.formatMessage({
        description: 'VISITATORI_LOGGATI_TOTALI_PRODOTTO',
        defaultMessage: 'Total signed in products visitors',
      }),
      VISITATORI_NON_LOGGATI_TOTALI_BRAND: intl.formatMessage({
        description: 'VISITATORI_NON_LOGGATI_TOTALI_BRAND',
        defaultMessage: 'Total not signed in brand visitors',
      }),
      VISITATORI_NON_LOGGATI_TOTALI_PRODOTTO: intl.formatMessage({
        description: 'VISITATORI_NON_LOGGATI_TOTALI_PRODOTTO',
        defaultMessage: 'Total not signed in products visitors',
      }),
      NUMERO_MEDIO_PRODOTTI_VISUALIZZATI_BRAND: intl.formatMessage({
        description: 'NUMERO_MEDIO_PRODOTTI_VISUALIZZATI_BRAND',
        defaultMessage: 'Average number of products viewed by users',
      }),
      NUMERO_SESSIONI_LOGGATI: intl.formatMessage({
        description: 'NUMERO_SESSIONI_LOGGATI',
        defaultMessage: 'Number signed in sessions',
      }),
      NUMERO_SESSIONI_NON_LOGGATI: intl.formatMessage({
        description: 'NUMERO_SESSIONI_NON_LOGGATI',
        defaultMessage: 'Number not signed in sessions',
      }),
      PROVENIENZA_ALTRO: intl.formatMessage({
        description: 'PROVENIENZA_ALTRO',
        defaultMessage: 'Other',
      }),
      PROVENIENZA_CINA: intl.formatMessage({
        description: 'PROVENIENZA_CINA',
        defaultMessage: 'China',
      }),
      PROVENIENZA_ITALIA: intl.formatMessage({
        description: 'PROVENIENZA_ITALIA',
        defaultMessage: 'Italy',
      }),
      PROVENIENZA_RESTO_EUROPA: intl.formatMessage({
        description: 'PROVENIENZA_RESTO_EUROPA',
        defaultMessage: 'Rest of Europe',
      }),
      PROVENIENZA_USA: intl.formatMessage({
        description: 'PROVENIENZA_USA',
        defaultMessage: 'U.S.',
      }),
      A_D_PROFESSIONALS: intl.formatMessage({
        description: 'A_D_PROFESSIONALS',
        defaultMessage: 'A&D professionals',
      }),
      AGENTI: intl.formatMessage({
        description: 'AGENTI',
        defaultMessage: 'Agents',
      }),
      BUYERS: intl.formatMessage({
        description: 'BUYERS',
        defaultMessage: 'Buyers',
      }),
      FORNITORI: intl.formatMessage({
        description: 'FORNITORI',
        defaultMessage: 'Suppliers',
      }),
      INTERIOR_CONTRACTORS: intl.formatMessage({
        description: 'INTERIOR_CONTRACTORS',
        defaultMessage: 'Contractors',
      }),
      MEDIA_PRESS: intl.formatMessage({
        description: 'MEDIA_PRESS',
        defaultMessage: 'Media & Press',
      }),
      PRIVATI_DESIGN_LOVERS: intl.formatMessage({
        description: 'PRIVATI_DESIGN_LOVERS',
        defaultMessage: 'Design lovers',
      }),
      RETAILERS: intl.formatMessage({
        description: 'RETAILERS',
        defaultMessage: 'Retailers',
      }),
      SPONSOR: intl.formatMessage({
        description: 'SPONSOR',
        defaultMessage: 'Sponsor',
      }),
      WHOLESALERS: intl.formatMessage({
        description: 'WHOLESALERS',
        defaultMessage: 'Wholesalers',
      }),
      OPERATORE_DEL_SETTORE: intl.formatMessage({
        description: 'OPERATORE_DEL_SETTORE',
        defaultMessage: 'Operators in the sector',
      }),
      NUM_MEDIO_EVENTI_PARTECIPATI: intl.formatMessage({
        description: 'NUM_MEDIO_EVENTI_PARTECIPATI',
        defaultMessage: 'Average Nb. of Participants per Event',
      }),
      NUM_UTENTI_BOOKMARK_BRAND: intl.formatMessage({
        description: 'NUM_UTENTI_BOOKMARK_BRAND',
        defaultMessage: 'Number of users following the brand',
      }),
      NUM_UTENTI_BOOKMARK_PRODOTTO: intl.formatMessage({
        description: 'NUM_UTENTI_BOOKMARK_PRODUCTS',
        defaultMessage: 'Number of users following at least one product',
      }),
      NUM_UTENTI_RICHIESTA_CONTATTO_BRAND: intl.formatMessage({
        description: 'NUM_UTENTI_RICHIESTA_CONTATTO_BRAND',
        defaultMessage: 'Number of users who contacted the brand',
      }),
    },
    options: {
      labels: {
        label: intl.formatMessage({
          description: 'Time Range Selection',
          defaultMessage: 'Select time period',
        }),
        resetLabel: intl.formatMessage({
          description: 'All-Time',
          defaultMessage: 'All',
        }),
      },
      ALL: intl.formatMessage({
        description: 'All-Time',
        defaultMessage: 'All',
      }),
      YTD: intl.formatMessage({
        description: 'Start of the Year',
        defaultMessage: 'Current year',
      }),
      MTD: intl.formatMessage({
        description: 'Start of the Month',
        defaultMessage: 'Start of the Month',
      }),
      '15GG_ROLL': intl.formatMessage({
        description: 'Last 15 Days',
        defaultMessage: 'Last 15 Days',
      }),
      '30GG_ROLL': intl.formatMessage({
        description: 'Last 30 Days',
        defaultMessage: 'Last 30 Days',
      }),
    },
  }),
  Tickets: (intl) => ({
    page: {
      title: intl.formatMessage({
        description: 'Tickets title',
        defaultMessage: 'Tickets',
      }),
      subtitle: intl.formatMessage({
        description: 'tickets page subtitle',
        defaultMessage: 'Personal Area',
      }),
      summary: intl.formatMessage({
        description: 'tickets page summary',
        defaultMessage:
          'Purchase your entrance tickets and the exhibition catalogue, you will receive by mail your ticket and the voucher to collect your copy of the catalogue at the fairgrounds.',
      }),
      textOne: intl.formatMessage(
        {
          description: 'tickets page textOne',
          defaultMessage:
            '<strong>All tickets are person-specific and non-transferable</strong>. You can check out information and validity of each ticket type by clicking on symbol info. At the moment of ticket purchase, you will have to enter details of each visitor and book the date/s of the visit.',
        },
        { ...htmlParserOptions }
      ),
      textTwo: intl.formatMessage(
        {
          description: 'tickets page textTwo',
          defaultMessage:
            '<strong>Payment</strong> can be made by using one of the following credit cards: Visa, Mastercard, American Express, Union Pay or via Google Pay and Apple Pay digital wallet. To avoid problems at the moment of online purchase, please make sure that your credit card is enabled to conduct transactions online and verify with your bank its security settings.',
        },
        { ...htmlParserOptions }
      ),
      textThree: intl.formatMessage(
        {
          description: 'tickets page textThree',
          defaultMessage: 'For information and assistance: ph.',
        },
        { ...htmlParserOptions }
      ),
      tickets: {
        title: intl.formatMessage({
          description: 'Tickets container title',
          defaultMessage: 'Tickets',
        }),
      },
      dialog: {
        info: {
          title: intl.formatMessage({
            description: 'Tickets dialog info title',
            defaultMessage: 'Tickets',
          }),
        },
      },
      ticketCard: {
        price: intl.formatMessage({
          description: 'ticket card price',
          defaultMessage: 'PRICE',
        }),
        quantity: intl.formatMessage({
          description: 'ticket card price',
          defaultMessage: 'QUANTITY',
        }),
      },
      selectedTicketsCard: {
        title: intl.formatMessage({
          description: 'selectedTicketsCard title',
          defaultMessage: 'Selected Items',
        }),
        addTitle: intl.formatMessage({
          description: 'selectedTicketsCard add title',
          defaultMessage: 'Add Items',
        }),
        emptyCart: intl.formatMessage({
          description: 'selectedTicketsCard emptyCart',
          defaultMessage: 'Cart is empty, select ticket to proceed',
        }),
        addEmptyCart: intl.formatMessage({
          description: 'selectedTicketsCard add emptyCart',
          defaultMessage: 'There is no new product',
        }),
        quantity: intl.formatMessage({
          description: 'selectedTicketsCard quantity',
          defaultMessage: 'Quantity',
        }),
        proceed: intl.formatMessage({
          description: 'selectedTicketsCard proceed',
          defaultMessage: 'Proceed',
        }),
        view: intl.formatMessage({
          description: 'selectedTicketsCard view',
          defaultMessage: 'View Items',
        }),
        hide: intl.formatMessage({
          description: 'selectedTicketsCard hide',
          defaultMessage: 'Hide Items',
        }),
        subtotal: intl.formatMessage({
          description: 'selectedTicketsCard subtotal',
          defaultMessage: 'Subtotal',
        }),
        remove: intl.formatMessage({
          description: 'selectedTicketsCard remove',
          defaultMessage: 'REMOVE',
        }),
      },
    },
    edit: {
      backButton: intl.formatMessage({
        description: 'edit tickets page back button',
        defaultMessage: 'Back',
      }),
      title: intl.formatMessage({
        description: 'edit tickets page title',
        defaultMessage: 'Edit Ticket',
      }),
      assignTitle: intl.formatMessage({
        description: 'edit assign tickets page title',
        defaultMessage: 'Assign Ticket',
      }),
      subTitle: intl.formatMessage(
        {
          description: 'edit tickets page title',
          defaultMessage:
            "To proceed with the order, you will have to enter details of each visitor (i.e. Name and family name, Country, e-mail, activity). First name and family name will be printed on the tickets. When personalising each ticket, <strong>please also select the dates of the visit</strong>. After the order is confirmed, you will be able to change them in the 'Order Summary' page. The days you select will be printed on the ticket, if you change one or more dates, please remember to download and print your updated ticket. <strong>Entry will not be allowed on an unbooked day differing from that indicated on the ticket.</strong>",
        },
        { ...htmlParserOptions }
      ),
      dialog: {
        action: {
          titleDelete: intl.formatMessage({
            description: 'Tickets dialog action delete title',
            defaultMessage: 'Tickets',
          }),
          subtitleDelete: intl.formatMessage({
            description: 'Tickets dialog action delete subtitle',
            defaultMessage: 'You are about to delete a product',
          }),
          textDelete: intl.formatMessage({
            description: 'Tickets dialog action delete text',
            defaultMessage:
              'If you proceed the item will be removed from the cart',
          }),
          textDeleteSure: intl.formatMessage({
            description: 'Tickets dialog action delete text sure',
            defaultMessage: 'Are you sure?',
          }),
          btn: {
            cancel: intl.formatMessage({
              description: 'Tickets dialog action delete btn cancel',
              defaultMessage: 'Cancel',
            }),
            delete: intl.formatMessage({
              description: 'Tickets dialog action delete btn delete',
              defaultMessage: 'Delete',
            }),
          },
        },
      },
      ticketEditCard: {
        invalidEmail: intl.formatMessage({
          description: 'invalidEmail ticketEdit',
          defaultMessage: 'is not a valid email address',
        }),
        invalidPhone: intl.formatMessage({
          description: 'invalidEmail ticketEdit',
          defaultMessage:
            'is not a valid phone number. It must contain at least 7 digits.',
        }),
        invalidRange: intl.formatMessage({
          description: 'invalidRange ticketEdit',
          defaultMessage:
            'Another ticket has the same email registered for the same date. Please provide another email or another date',
        }),
        saveButton: intl.formatMessage({
          description: 'edit TicketsCard proceed',
          defaultMessage: 'Save',
        }),
        title: intl.formatMessage({
          description: 'edit tickets card title',
          defaultMessage: 'Ticket',
        }),
        edit: intl.formatMessage({
          description: 'edit tickets card edit',
          defaultMessage: 'Edit',
        }),
        assign: intl.formatMessage({
          description: 'edit tickets card assign',
          defaultMessage: 'Assign',
        }),
        delete: intl.formatMessage({
          description: 'edit tickets card delete',
          defaultMessage: 'Delete',
        }),
        fields: {
          privateStudent: intl.formatMessage({
            description: 'private student label',
            defaultMessage: 'Private - Student',
          }),
          firstname: {
            label: intl.formatMessage({
              description: 'first name ticket label',
              defaultMessage: 'First Name*',
            }),
            error: intl.formatMessage({
              description: 'first name ticket Error',
              defaultMessage: 'First Name is required',
            }),
          },
          lastname: {
            label: intl.formatMessage({
              description: 'lastName ticket label',
              defaultMessage: 'Last Name*',
            }),
            error: intl.formatMessage({
              description: 'lastName ticket Error',
              defaultMessage: 'Last Name is required',
            }),
          },
          email: {
            label: intl.formatMessage({
              description: 'email ticket label',
              defaultMessage: 'Email*',
            }),
            error: intl.formatMessage({
              description: 'email ticket Error',
              defaultMessage: 'Email is required',
            }),
          },
          sendToThisEmail: {
            label: intl.formatMessage({
              description: 'send to this email ticket label',
              defaultMessage: 'Send ticket also to this email*',
            }),
          },
          phone: {
            label: intl.formatMessage({
              description: 'phone ticket label',
              defaultMessage: 'Phone*',
            }),
            error: intl.formatMessage({
              description: 'phone ticket Error',
              defaultMessage: 'Phone is required',
            }),
            searchPlaceholder: intl.formatMessage({
              description: 'phone ticket searchPlaceholder Error',
              defaultMessage: 'Search...',
            }),
            searchNotFound: intl.formatMessage({
              description: 'phone ticket searchNotFound Error',
              defaultMessage: 'No entries to show',
            }),
          },
          company: {
            label: intl.formatMessage({
              description: 'company ticket label',
              defaultMessage: 'Company Name*',
            }),
            error: intl.formatMessage({
              description: 'company ticket Error',
              defaultMessage: 'Company Name is required',
            }),
          },
          role: {
            label: intl.formatMessage({
              description: 'role ticket label',
              defaultMessage: 'Select Role*',
            }),
            error: intl.formatMessage({
              description: 'role ticket Error',
              defaultMessage: 'Role is required',
            }),
          },
          sdm_other_role_in_company: {
            label: intl.formatMessage({
              description: 'other role ticket label',
              defaultMessage: 'Other Role*',
            }),
            error: intl.formatMessage({
              description: 'other role ticket Error',
              defaultMessage: 'Other Role is required',
            }),
          },
          country: {
            label: intl.formatMessage({
              description: 'nation ticket label',
              defaultMessage: 'Select Nation*',
            }),
            error: intl.formatMessage({
              description: 'nation ticket Error',
              defaultMessage: 'Nation is required',
            }),
          },
          district: {
            label: intl.formatMessage({
              description: 'district ticket label',
              defaultMessage: 'Select District*',
            }),
            error: intl.formatMessage({
              description: 'district ticket Error',
              defaultMessage: 'District is required',
            }),
          },
          city: {
            label: intl.formatMessage({
              description: 'city ticket label',
              defaultMessage: 'City*',
            }),
            error: intl.formatMessage({
              description: 'city ticket Error',
              defaultMessage: 'City is required',
            }),
          },
          region: {
            label: intl.formatMessage({
              description: 'region ticket label',
              defaultMessage: 'Select Region',
            }),
          },
          date: {
            label: intl.formatMessage({
              description: 'date ticket label',
              defaultMessage: 'dates',
            }),
            error: intl.formatMessage({
              description: 'date ticket label',
              defaultMessage: 'Dates are required',
            }),
          },
          dateSingular: {
            label: intl.formatMessage({
              description: 'date ticket dateSingular label',
              defaultMessage: 'date',
            }),
          },
          select: {
            label: intl.formatMessage({
              description: 'select ticket label',
              defaultMessage: 'Select',
            }),
          },
          notifyCustomer: {
            label: intl.formatMessage({
              description: 'notify ticket customer label',
              defaultMessage: 'Send mail to yourself',
            }),
          },
          notifyOwners: {
            label: intl.formatMessage({
              description: 'notify ticket owners label',
              defaultMessage: 'Send mail to owners',
            }),
          },
          owner_flag_privacy_1: {
            label: intl.formatMessage(
              {
                description: 'privacy 1 ticket label',
                defaultMessage:
                  '*I confirm that I have read and understood the Privacy Policy - INFORMATIVE PLATFORM pursuant to Article 13 of Regulation (EU) 2016/679 available at the link: <privacy>https://www.salonemilano.it/en/privacy-policy</privacy>',
              },
              {
                ...htmlParserOptions,
              }
            ),
            error: intl.formatMessage({
              description: 'privacy 1 ticket error',
              defaultMessage: 'This field is required',
            }),
          },
          owner_flag_privacy_1_mobile: {
            label: intl.formatMessage(
              {
                description: 'privacy 1 ticket label mobile',
                defaultMessage:
                  '*I confirm that I have read and understood the Privacy Policy - INFORMATIVE PLATFORM pursuant to Article 13 of Regulation (EU) 2016/679 <privacy>available at this link</privacy>',
              },
              {
                ...htmlParserOptions,
              }
            ),
          },
          owner_flag_privacy_2: {
            label: intl.formatMessage({
              description: 'privacy 2 ticket label',
              defaultMessage:
                'I consent to the processing of my personal data for the receipt of communications for marketing purposes and for sending communications of an institutional, commercial and promotional nature, including newsletters and invitations to initiatives organized by Federlegno Arredo Eventi S.p.A. (Salone del Mobile.Milano) and/or subsidiaries and/or affiliates, surveys and market research.',
            }),
          },
          owner_flag_privacy_3: {
            label: intl.formatMessage({
              description: 'privacy 3 ticket label',
              defaultMessage:
                'I consent to the processing of my personal data for the purposes of profiling and analysis of consumer habits by Federlegno Arredo Eventi S.p.A. (Salone del Mobile.Milano) and/or subsidiaries and/or associates.',
            }),
          },
          owner_flag_privacy_4: {
            label: intl.formatMessage({
              description: 'privacy 4 ticket label',
              defaultMessage:
                'I hereby provide my consent to the transfer of my personal data to third parties.',
            }),
          },
          month: intl.formatMessage({
            description: 'month june label',
            defaultMessage: 'June',
          }),
          sdm_operator_type: {
            label: intl.formatMessage({
              description: 'operator type ticket label',
              defaultMessage: 'Operator Type*',
            }),
            error: intl.formatMessage({
              description: 'operator type ticket Error',
              defaultMessage: 'Operator Type is required',
            }),
          },
          sdm_operator_sub_type: {
            label: intl.formatMessage({
              description: 'suboperator type ticket label',
              defaultMessage: 'Operator Subtype*',
            }),
            error: intl.formatMessage({
              description: 'suboperator type ticket Error',
              defaultMessage: 'Operator Subtype is required',
            }),
          },
          sdm_other_type: {
            label: intl.formatMessage({
              description: 'suboperator other type ticket label',
              defaultMessage: 'Other Operator Subtype*',
            }),
            error: intl.formatMessage({
              description: 'suboperator other type ticket Error',
              defaultMessage: 'Other Operator Subtype is required',
            }),
          },
          types: {
            ret: intl.formatMessage({
              description: 'ret ticket label',
              defaultMessage: 'Retailer',
            }),
            ret_bou: intl.formatMessage({
              description: 'ret_bou ticket label',
              defaultMessage: 'Boutiques',
            }),
            ret_cat: intl.formatMessage({
              description: 'ret_bou ticket label',
              defaultMessage: 'Chain',
            }),
            ret_dep: intl.formatMessage({
              description: 'ret_dep ticket label',
              defaultMessage: 'Department store',
            }),
            ret_gac: intl.formatMessage({
              description: 'ret_gac ticket label',
              defaultMessage: 'Purchasing group',
            }),
            ret_oth: intl.formatMessage({
              description: 'ret_gac ticket label',
              defaultMessage: 'Other',
            }),
            adp: intl.formatMessage({
              description: 'adp ticket label',
              defaultMessage: 'A&D professional',
            }),
            adp_arc: intl.formatMessage({
              description: 'adp_arc ticket label',
              defaultMessage: 'Architect',
            }),
            adp_dsn: intl.formatMessage({
              description: 'adp_dsn ticket label',
              defaultMessage: 'Designer',
            }),
            adp_int: intl.formatMessage({
              description: 'adp_int ticket label',
              defaultMessage: 'Interior designer',
            }),
            adp_lig: intl.formatMessage({
              description: 'adp_lig ticket label',
              defaultMessage: 'Lighting designer',
            }),
            adp_geo: intl.formatMessage({
              description: 'adp_geo ticket label',
              defaultMessage: 'Surveyor',
            }),
            adp_oth: intl.formatMessage({
              description: 'adp_oth ticket label',
              defaultMessage: 'Other',
            }),
            apa: intl.formatMessage({
              description: 'apa ticket label',
              defaultMessage: 'Contractor',
            }),
            apa_dds: intl.formatMessage({
              description: 'apa_dds ticket label',
              defaultMessage: 'Facility Manager',
            }),
            apa_gnc: intl.formatMessage({
              description: 'apa_gnc ticket label',
              defaultMessage: 'General contractor',
            }),
            apa_svl: intl.formatMessage({
              description: 'apa_svl ticket label',
              defaultMessage: 'Real estate & Developer',
            }),
            apa_oth: intl.formatMessage({
              description: 'apa_oth ticket label',
              defaultMessage: 'Other',
            }),
            frn: intl.formatMessage({
              description: 'frn ticket label',
              defaultMessage: 'Supplier',
            }),
            frn_fdc: intl.formatMessage({
              description: 'frn_fdc ticket label',
              defaultMessage: 'Supplier of components',
            }),
            frn_fdm: intl.formatMessage({
              description: 'frn_fdc ticket label',
              defaultMessage: 'Supplier of raw materials',
            }),
            frn_fds: intl.formatMessage({
              description: 'frn_fdc ticket label',
              defaultMessage: 'Suppliers of services',
            }),
            grs: intl.formatMessage({
              description: 'grs ticket label',
              defaultMessage: 'Wholesaler',
            }),
            grs_dsr: intl.formatMessage({
              description: 'grs_dsr ticket label',
              defaultMessage: 'Supplier',
            }),
            grs_exp: intl.formatMessage({
              description: 'grs_exp ticket label',
              defaultMessage: 'Exporter',
            }),
            grs_imp: intl.formatMessage({
              description: 'grs_dsr ticket label',
              defaultMessage: 'Importer',
            }),
            grs_oth: intl.formatMessage({
              description: 'grs_dsr ticket label',
              defaultMessage: 'Other',
            }),
            acq: intl.formatMessage({
              description: 'acq ticket label',
              defaultMessage: 'Buyer',
            }),
            acq_sdb: intl.formatMessage({
              description: 'acq_sdb ticket label',
              defaultMessage: 'Buying services company',
            }),
            acq_ret: intl.formatMessage({
              description: 'acq_ret ticket label',
              defaultMessage: 'Retailer',
            }),
            acq_who: intl.formatMessage({
              description: 'acq_who ticket label',
              defaultMessage: 'Wholesaler',
            }),
            acq_dps: intl.formatMessage({
              description: 'acq_dps ticket label',
              defaultMessage: 'Department store',
            }),
            acq_gda: intl.formatMessage({
              description: 'acq_gda ticket label',
              defaultMessage: 'Purchasing group',
            }),
            acq_oth: intl.formatMessage({
              description: 'acq_oth ticket label',
              defaultMessage: 'Other',
            }),
            agn: intl.formatMessage({
              description: 'agn ticket label',
              defaultMessage: 'Agent',
            }),
            prv: intl.formatMessage({
              description: 'prv ticket label',
              defaultMessage: 'Private',
            }),
            prd: intl.formatMessage({
              description: 'prd ticket label',
              defaultMessage: 'Manufacturer',
            }),
            prd_ard: intl.formatMessage({
              description: 'prd_ard ticket label',
              defaultMessage: 'Furniture',
            }),
            prd_aru: intl.formatMessage({
              description: 'prd_aru ticket label',
              defaultMessage: 'Office furniture',
            }),
            prd_arb: intl.formatMessage({
              description: 'prd_arb ticket label',
              defaultMessage: 'Bathroom furniture and accessories',
            }),
            prd_cda: intl.formatMessage({
              description: 'prd_cda ticket label',
              defaultMessage: 'Furnishing accessories',
            }),
            prd_arc: intl.formatMessage({
              description: 'prd_arc ticket label',
              defaultMessage: 'Kitchen furniture',
            }),
            prd_ele: intl.formatMessage({
              description: 'prd_ele ticket label',
              defaultMessage: 'Built-in appliances',
            }),
            prd_lig: intl.formatMessage({
              description: 'prd_lig ticket label',
              defaultMessage: 'Lighting',
            }),
            prd_oth: intl.formatMessage({
              description: 'prd_oth ticket label',
              defaultMessage: 'Other',
            }),
            mrk: intl.formatMessage({
              description: 'mrk ticket label',
              defaultMessage: 'Marketing and Communication',
            }),
            sdm_role_in_company: {
              businessOwner: intl.formatMessage({
                description: 'businessOwner ticket label',
                defaultMessage:
                  'Business Owner, Business Partner, Self Employed',
              }),
              owner: intl.formatMessage({
                description: 'owner ticket label',
                defaultMessage: 'Owner / Managing Director',
              }),
              senior: intl.formatMessage({
                description: 'senior ticket label',
                defaultMessage: 'Senior professional',
              }),
              junior: intl.formatMessage({
                description: 'junior ticket label',
                defaultMessage: 'Junior professional',
              }),
              projectManager: intl.formatMessage({
                description: 'projectManager ticket label',
                defaultMessage: 'Project Manager',
              }),
              purchasingDepartment: intl.formatMessage({
                description: 'purchasingDepartment ticket label',
                defaultMessage: 'Purchasing Department',
              }),
              ceo: intl.formatMessage({
                description: 'ceo ticket label',
                defaultMessage: 'Owner / CEO',
              }),
              storeManager: intl.formatMessage({
                description: 'storeManager ticket label',
                defaultMessage: 'Store Manager',
              }),
              retailOperations: intl.formatMessage({
                description: 'reatilOperations ticket label',
                defaultMessage: 'Retail Operations Manager',
              }),
              buyer: intl.formatMessage({
                description: 'buyer ticket label',
                defaultMessage: 'Buyer',
              }),
              sales: intl.formatMessage({
                description: 'sales ticket label',
                defaultMessage: 'Sales',
              }),
              architect: intl.formatMessage({
                description: 'architect ticket label',
                defaultMessage: 'Architect',
              }),
              assembler: intl.formatMessage({
                description: 'assembler ticket label',
                defaultMessage: 'Assembler',
              }),
              divisionManager: intl.formatMessage({
                description: 'divisionManager ticket label',
                defaultMessage: 'Division Manager',
              }),
              salesDepartment: intl.formatMessage({
                description: 'salesDepartment ticket label',
                defaultMessage: 'Sales Department',
              }),
              salesDepartmentFrn: intl.formatMessage({
                description: 'salesDepartmentFrn ticket label',
                defaultMessage: 'Sales Department',
              }),
              marketingDepartment: intl.formatMessage({
                description: 'marketingDepartment ticket label',
                defaultMessage: 'Marketing department',
              }),
              employeeSenior: intl.formatMessage({
                description: 'employeeSenior ticket label',
                defaultMessage: 'Employee - Senior professional',
              }),
              employeeJunior: intl.formatMessage({
                description: 'employeeJunior ticket label',
                defaultMessage: 'Employee - Junior professional',
              }),
              employeeProjectManager: intl.formatMessage({
                description: 'employeeProjectManager ticket label',
                defaultMessage: 'Employee - Project Manager',
              }),
              director: intl.formatMessage({
                description: 'director ticket label',
                defaultMessage: 'CEO, Director, Executive',
              }),
              manager: intl.formatMessage({
                description: 'manager ticket label',
                defaultMessage: 'Manager, Employee, Assistant',
              }),
              artisan: intl.formatMessage({
                description: 'artisan ticket label',
                defaultMessage: 'Technician, Artisan, Production',
              }),
              teacher: intl.formatMessage({
                description: 'teacher ticket label',
                defaultMessage: 'Academic, Researcher, Teacher',
              }),
              other: intl.formatMessage({
                description: 'other ticket label',
                defaultMessage: 'Other',
              }),
            },
          },
        },
      },
    },
    merchandising: {
      title: intl.formatMessage({
        description: 'merchandising title',
        defaultMessage: 'Catalogue',
      }),
      subTitle: intl.formatMessage({
        description: 'merchandising subtitle',
        defaultMessage:
          'You can also purchase the 2023 General Catalogue (Salone del Mobile, International Furnishing Accessories Exhibition, Workplace3.0, S.Project, Euroluce). Catalogues will not be shipped, you will have to collect them at the Catalogue Delivery desk (in the Service Centre, ground floor) by presenting the voucher downloadable in the Order Summary section.',
      }),
      backButton: intl.formatMessage({
        description: 'edit tickets page back button',
        defaultMessage: 'Back',
      }),
      card: {
        item: intl.formatMessage({
          description: 'merchandising item label',
          defaultMessage: 'ITEM',
        }),
        price: intl.formatMessage({
          description: 'merchandising price label',
          defaultMessage: 'PRICE',
        }),
        quantity: intl.formatMessage({
          description: 'merchandising quantity label',
          defaultMessage: 'QUANTITY',
        }),
      },
    },
    recap: {
      title: intl.formatMessage({
        description: 'recap page title',
        defaultMessage: 'Your purchase total is',
      }),
      subTitle: intl.formatMessage({
        description: 'recap page subtitle',
        defaultMessage:
          'Check that the items in your cart are correct and proceed with payment. Payment can be made by using one of the following credit cards: Visa, Mastercard, American Express, Union Pay or via Google Pay and Apple Pay digital wallet.',
      }),
      backButton: intl.formatMessage({
        description: 'recap page back button',
        defaultMessage: 'Back',
      }),
      subtitle: intl.formatMessage({
        description: 'recap page subtitle',
        defaultMessage: 'Order recap',
      }),
      warningMsg: intl.formatMessage({
        description: 'recap page warningMsg',
        defaultMessage: 'We remember you that',
      }),
      addMore: {
        title: intl.formatMessage({
          description: 'recap page add more title',
          defaultMessage: 'Add catalogues',
        }),
        btn: intl.formatMessage({
          description: 'recap page more title',
          defaultMessage: 'Add',
        }),
        subTitle: intl.formatMessage({
          description: 'recap page more subtitle',
          defaultMessage:
            'You can still add to cart the 2023 General Catalogue (Salone del Mobile, International Furnishing Accessories Exhibition, Workplace3.0, S.Project, Euroluce).',
        }),
      },
      total: intl.formatMessage({
        description: 'recap page total',
        defaultMessage: 'Total',
      }),
      addTicket: intl.formatMessage({
        description: 'recap page addTicket',
        defaultMessage: 'Add Ticket',
      }),
      payNow: intl.formatMessage({
        description: 'recap page payNow',
        defaultMessage: 'Pay now',
      }),
      card: {
        item: intl.formatMessage({
          description: 'recap item label',
          defaultMessage: 'ITEM',
        }),
        price: intl.formatMessage({
          description: 'recap price label',
          defaultMessage: 'PRICE',
        }),
        quantity: intl.formatMessage({
          description: 'recap quantity label',
          defaultMessage: 'QUANTITY',
        }),
        date: intl.formatMessage({
          description: 'recap date label',
          defaultMessage: 'Date',
        }),
        edit: intl.formatMessage({
          description: 'recap tickets card edit',
          defaultMessage: 'Edit',
        }),
        delete: intl.formatMessage({
          description: 'recap tickets card delete',
          defaultMessage: 'Delete',
        }),
      },
      accept: intl.formatMessage(
        {
          description: 'recap page accept',
          defaultMessage:
            "<spaced><strong>Federlegno Arredo Eventi S.p.A. is the organizer of the events named Salone Internazionale del Mobile, EuroCucina, Euroluce, Salone Internazionale del Bagno, Salone Internazionale del Complemento d'Arredo, Workplace3.0 (hereinafter, EVENTS), jointly identified with the registered and protected trademark at the national, EU and international level, of which it is the owner, as follows: Salone del Mobile.Milano. Federlegno Arredo Eventi S.p.A. also organizes the events FTK - Technology For the Kitchen and S.Project.</strong></spaced><spaced><strong>Federlegno Arredo Eventi S.p.A. (hereinafter, ORGANIZER or FLAE) is in charge of the online sales service of admission tickets and general catalogues of the event, using its own ticketing system regulated by the conditions below.</strong></spaced><spaced><strong><uppercase>REGULATION FOR THE PURCHASE OF GOODS AND SERVICES</uppercase></strong></spaced><spaced>The following statements regulate the relations between FLAE as provider of the service (hereinafter referred to as the SERVICE) and the users of this service (hereinafter referred to as USERS). The USER who takes advantage of the SERVICE is required to comply with all the general conditions contained in this regulation. This regulation must therefore be read and approved in its entirety before completing the purchase.</spaced><spaced><div>Art. 1 - <strong>OBJECT OF THE SERVICE</strong></div><div>The SERVICE has as its object the online sale of admission tickets and general catalogues of the event (hereinafter referred to as CATALOGUES) by the ORGANIZER of the EVENTS.</div></spaced><spaced></spaced><spaced><div>Art. 2 - <strong>PAYMENT FOR THE SERVICE</strong></div><div>Payment for the SERVICE may be made: i) by credit card - Visa, Mastercard, Amex or Union Pay; and ii) by digital wallet - Google Pay and Apple Pay. Payment is made through a virtual payment system in secure mode with irreversible 128-bit encryption. By this method, the transaction takes place exclusively in the banking sector. FLAE does not have in any way access to the data of the USER's credit card. FLAE therefore has no responsibility for the numbers and credit card data provided to the bank at the time of the online purchase of the admission ticket and catalogues. With reference to the purchase of admission tickets, from the moment of opening of the online sale until 23.59 on April 17, 2023, the pre-sale rates indicated on the dedicated web page will be applied; from 00.00 h on 18 April 2023 and until the end of the EVENTS, the full rates also indicated on the dedicated web page will apply. According to Article 74 - quater, par. 2 of the Presidential Decree no. 633/1972 tickets are fiscal documents to all intents and purposes, hence they constitute evidence of the ticket's value. Therefore invoices will not be issued.</div></spaced><spaced></spaced><spaced><div>Art. 3 - <strong>OBLIGATIONS OF THE PURCHASER AND THE HOLDER OF THE CREDIT CARD AND DIGITAL WALLET</strong></div><spaced>The USER undertakes to view, carefully read and accept the contractual clauses referred to in this regulation, as a necessary condition for purchase, since these are clauses drawn up in accordance with Article 12 of Legislative Decree 70/03 (electronic commerce).</spaced><spaced>The purchase order must be forwarded by the holder of the credit card or digital wallet.</spaced><spaced>Please note that the improper use of a credit card is prosecuted criminally under Article 12 of Legislative Decree May 3, 1991 no. 143, converted with amendments into Law July 5, 1991 no. 197, for transactions performed on the internet by providing the identificatory and operational data of another person's credit card, acquired fraudulently by the agent.</spaced><spaced><strong><underline>Effectiveness of the agreement and Documentation to be kept.</underline></strong></spaced><spaced>The order and reception of confirmation of the order are considered received when the parties, to whom they are addressed, have the opportunity to access them.</spaced><div>Therefore, the USER must carefully keep:</div><div>a) <underline>in the case of the admission tickets</underline>: order confirmation e-mail with the summary of the purchase and the e-mail containing the admission tickets in .pdf format, which are the document necessary for direct access to the EVENTS; </div><spaced>b) <underline>in the case of the CATALOGUES</underline>: order confirmation e-mail with the summary of the purchase, e-mail containing the voucher in .pdf format for the receipt of the CATALOGUES at the Rho (MI) exhibition center during the days of the EVENTS and the instructions for the possible download of the voucher itself.</spaced><spaced>It is understood that, with the transmission of the .pdf of the admission tickets and/or the voucher for the receipt of the CATALOGUES and the instructions for downloading the voucher, FLAE will have correctly and accurately fulfilled the obligations acquired, with the effect that the holder of the credit card or digital wallet, used for the online operation is unable to request the bank to refund the sums used for this purpose, under penalty of compensation for damages in favor of FLAE.</spaced><spaced>It should be noted that failure to collect the catalogues at the Rho (MI) exhibition center will not give rise to any refund.</spaced></spaced><spaced><div>Art. 4 - <strong>RIGHTS AND OBLIGATIONS OF FLAE</strong></div><spaced>FLAE may suspend the SERVICE in  part or in whole for unforeseeable technical reasons, or for any changes intended to improve the service itself.</spaced><spaced>FLAE is responsible for the CATALOGUES until the confirmation of payment relating to the purchase of the same. The loss and/or mislaying of and/or delay in the delivery of admission tickets and/or vouchers essential for the collection of the CATALOGUES by third parties will represent unforeseeable circumstances on the part of FLAE. Furthermore, FLAE will not be liable for the non-use of admission tickets (even if delivered and/or collected) and/or failure to collect the CATALOGUES by the USER. In such cases, all right to reimbursement of the admission tickets and/or the price of the CATALOGUES by the ORGANIZER is excluded.</spaced></spaced><spaced><div>Art. 5 - <strong>CANCELLATION OF EVENT OR CANCELLATION OF ADMISSION TICKETS</strong></div><div><underline>With reference to admission tickets</underline>, in the event that one or more EVENTS are canceled, the USER will be entitled to a refund of the relative admission ticket purchased. To this end, the USER must submit a request for reimbursement in writing to be sent to the ORGANIZER: i) by registered letter with return receipt to the address: Foro Buonaparte no. 65, Milan; or ii) by e-mail to the address tickets@salonemilano.it, no later than May 31, 2023. The shipping costs related to the refund request will be borne by the USER. In the event of cancellation of one or more EVENTS, the respective entrance tickets will be canceled in the manner referred to under Article 7 of Ministerial Decree of July 13, 2000. The same cancelation procedures will apply in the case of cancelation of admission tickets due to incorrect issuance of the admission ticket itself. With the exception of the cases specified above, admission tickets cannot be canceled and consequently refunded. The USER will therefore be entitled to a refund of the sums paid for the purchase of the admission ticket, minus the bank charges, incurred by FLAE, provided that he/she has made the relative request in keeping with the above terms and methods. </div></spaced><spaced><div>Art. 6 - <strong>RIGHT OF WITHDRAWAL</strong></div><div><underline>With reference to the CATALOGUES</underline>, the right to exercise the right of withdrawal within 10 days from the time of purchase and in any case no later than the fifth working day before the start of the EVENTS is allowed. Withdrawal is exercised by written request to the ORGANIZER to be sent: i) by registered letter with return receipt to the following address: Milan, Foro Buonaparte no. 65; or ii) by e-mail to the address tickets@salonemilano.it, within the terms indicated above. In this case, the USER will be entitled to a refund of the sums paid for the purchase of the CATALOGUES, minus the bank charges incurred by FLAE, provided that he/she has exercised the right of withdrawal in compliance with the abovementioned methods and times and, in any case, before the EVENTS in which he/she had an interest in participating, while any possible request for withdrawal and/or reimbursement subsequent to the above EVENTS will not be valid.</div></spaced><spaced><div>Art. 7 - <strong>LIMITATIONS OF LIABILITY </strong></div><div>FLAE accepts no responsibility for direct or indirect damages in any way connected to the SERVICE. FLAE undertakes to provide the competent authorities without delay with all the information in its possession in order to allow the identification and prevention of any offenses committed on internet.</div></spaced><spaced><div>Art. 8 - <strong>ARBITRATION CLAUSE</strong></div><div>For any dispute, the Court of Milan is established as having exclusive jurisdiction.</div></spaced><spaced><div>Art. 9 - <strong>APPLICABLE LEGISLATION</strong></div><div>If not expressly referred to herein, Italian and EU legislation must be considered applicable.</div></spaced>",
        },
        {
          ...htmlParserOptions,
        }
      ),
      acceptTwo: intl.formatMessage(
        {
          description: 'recap page acceptTwo',
          defaultMessage:
            '<i>Pursuant to and for the purposes of Articles 1341 and 1342 of the Civil Code, the USER expressly declares approval of the following provisions of the REGULATION FOR THE PURCHASE OF GOODS AND SERVICES: Article 1 (OBJECT OF THE SERVICE), Article 2 (PAYMENT FOR THE SERVICE), Article 3 - OBLIGATIONS OF THE PURCHASER AND THE HOLDER OF THE CREDIT CARD AND DIGITAL WALLET; Art. 5 (CANCELLATION OF EVENT OR CANCELLATION OF ADMISSION TICKETS), Art. 6 (RIGHT OF WITHDRAWAL), and Art. 7 (LIMITATIONS OF LIABILITY).</i>',
        },
        {
          ...htmlParserOptions,
        }
      ),
      flag: intl.formatMessage({
        description: 'recap page flage',
        defaultMessage: 'Accept',
      }),
    },
    checkoutStripe: {
      error: intl.formatMessage({
        description: 'checkout page error',
        defaultMessage: 'An error occured, pleade try again later',
      }),
      preparing: intl.formatMessage({
        description: 'checkout page preparing',
        defaultMessage: 'We are preparing your order, please wait...',
      }),
    },
    pendingOrder: {
      title: intl.formatMessage({
        description: 'pendingOrder page title',
        defaultMessage: 'Your order has not been confirmed',
      }),
      text: intl.formatMessage({
        description: 'pendingOrder page text',
        defaultMessage:
          "You can find it in the Order Summary in 'Waiting' status: you can open it, check ticket details and go to payment page.",
      }),
    },
    success: {
      title: intl.formatMessage({
        description: 'success page title',
        defaultMessage: 'Thank you for your purchase!',
      }),
      text: intl.formatMessage({
        description: 'success page text',
        defaultMessage:
          'You can see a list of your orders and download both the tickets and the catalogue delivery voucher in the Order Summary page.',
      }),
      subtitle: intl.formatMessage({
        description: 'success page subtitle',
        defaultMessage: 'Order recap',
      }),
      button: intl.formatMessage({
        description: 'success page button',
        defaultMessage: 'Go to Order Summary',
      }),
      finalizing: intl.formatMessage({
        description: 'success page finalizing',
        defaultMessage: 'We are finalizing your order, please wait...',
      }),
      card: {
        item: intl.formatMessage({
          description: 'success item label',
          defaultMessage: 'ITEM',
        }),
        price: intl.formatMessage({
          description: 'success price label',
          defaultMessage: 'PRICE',
        }),
        quantity: intl.formatMessage({
          description: 'success quantity label',
          defaultMessage: 'QUANTITY',
        }),
        date: intl.formatMessage({
          description: 'success date label',
          defaultMessage: 'Date',
        }),
      },
    },
    myTickets: {
      title: intl.formatMessage({
        description: 'My Tickets title',
        defaultMessage: 'Order summary',
      }),
      showMore: intl.formatMessage({
        description: 'My Tickets showMore',
        defaultMessage: 'Show More',
      }),
      subtitle: intl.formatMessage({
        description: 'My Tickets subtitle',
        defaultMessage: 'Personal Area',
      }),
      textSubtitle: intl.formatMessage({
        description: 'My Tickets order subtitle',
        defaultMessage:
          'In this page all the orders that you have placed, both confirmed and waiting, are listed. Waiting orders have not been finalized due to an error in the payment process, click on the order you wish to confirm to open and complete it.',
      }),
      buttons: {
        createBr: intl.formatMessage({
          description: 'My Tickets title',
          defaultMessage: 'Buy Tickets',
        }),
      },
      dialog: {
        title: intl.formatMessage({
          description: 'My Tickets download error title',
          defaultMessage: 'ERROR',
        }),
        subtitle: intl.formatMessage({
          description: 'My Tickets download error subtitle',
          defaultMessage:
            'An error occured downloading the ticket, please try again later.',
        }),
        btn: {
          ok: intl.formatMessage({
            description: 'My Tickets download error subtitle btn ok',
            defaultMessage: 'OK',
          }),
        },
      },
      order: {
        title: intl.formatMessage({
          description: 'My Tickets order title',
          defaultMessage: 'Order',
        }),
        pendingMessage: intl.formatMessage({
          description: 'my tickets pensing message label',
          defaultMessage:
            'The order has not been confirmed, we suggest you to check if an error occurred during payment process. You can now complete it: simply check that all the tickets are correct and proceed with payment',
        }),
        contactUs: intl.formatMessage({
          description: 'My Tickets order contactUs',
          defaultMessage:
            'Please do not hesitate to contact us if you have any questions.',
        }),
        completeOrder: intl.formatMessage({
          description: 'My Tickets order completeOrder',
          defaultMessage: 'Complete order',
        }),
        confirmed: intl.formatMessage({
          description: 'My Tickets order confirmed',
          defaultMessage: 'Confirmed',
        }),
        pending: intl.formatMessage({
          description: 'My Tickets order pending',
          defaultMessage: 'Waiting',
        }),
        of: intl.formatMessage({
          description: 'My Tickets order of',
          defaultMessage: 'of',
        }),
        customService: intl.formatMessage({
          description: 'My Tickets order customService',
          defaultMessage: 'Customer Service',
        }),
        download: intl.formatMessage({
          description: 'My Tickets order download',
          defaultMessage: 'Download',
        }),
        card: {
          item: intl.formatMessage({
            description: 'my tickets item label',
            defaultMessage: 'ITEM',
          }),
          price: intl.formatMessage({
            description: 'my tickets price label',
            defaultMessage: 'PRICE',
          }),
          quantity: intl.formatMessage({
            description: 'my tickets quantity label',
            defaultMessage: 'QUANTITY',
          }),
          date: intl.formatMessage({
            description: 'my tickets date label',
            defaultMessage: 'Date',
          }),
          edit: intl.formatMessage({
            description: 'my tickets card edit',
            defaultMessage: 'Edit Date',
          }),
          download: intl.formatMessage({
            description: 'my tickets card download',
            defaultMessage: 'Download Ticket',
          }),
          voucher: intl.formatMessage({
            description: 'my tickets card download voucher',
            defaultMessage: 'Download Voucher',
          }),
        },
      },
      customServiceSection: {
        title: intl.formatMessage({
          description: 'customServiceSection title',
          defaultMessage: 'Can we help you?',
        }),
        subtitle: intl.formatMessage({
          description: 'customServiceSection subtitle',
          defaultMessage:
            'Our Customer Service will be happy to assist you with your requests.',
        }),
        cta: intl.formatMessage({
          description: 'customServiceSection cta',
          defaultMessage: 'Write your request',
        }),
        ctaInfo: intl.formatMessage({
          description: 'customServiceSection ctaInfo',
          defaultMessage: 'We will reply to you by e-mail as soon as possible.',
        }),
      },
    },
    checkout: {
      total: intl.formatMessage({
        description: 'checkout total',
        defaultMessage: 'Your purchase total',
      }),
      item: intl.formatMessage({
        description: 'checkout item',
        defaultMessage: 'item',
      }),
      quantity: intl.formatMessage({
        description: 'checkout quantity',
        defaultMessage: 'Qty',
      }),
      each: intl.formatMessage({
        description: 'checkout each',
        defaultMessage: 'each',
      }),
      details: intl.formatMessage({
        description: 'checkout details',
        defaultMessage: 'Enter your payment details',
      }),
      payNow: intl.formatMessage({
        description: 'checkout page buy now btn',
        defaultMessage: 'Pay Now',
      }),
      paymentStatus: {
        processing: intl.formatMessage({
          description: 'checkout page processing',
          defaultMessage: 'Your payment is processing.',
        }),
        error: intl.formatMessage({
          description: 'checkout page error',
          defaultMessage: 'Your payment was not successful, please try again.',
        }),
        default: intl.formatMessage({
          description: 'checkout page default',
          defaultMessage: 'Something went wrong.',
        }),
      },
    },
    myTicketEdit: {
      title: intl.formatMessage({
        description: 'My edit Tickets title',
        defaultMessage: 'Edit Date',
      }),
      subTitle: intl.formatMessage(
        {
          description: 'My edit Tickets subTitle',
          defaultMessage:
            'The date/s you booked for the visit will be shown on each ticket, if you change one or more dates, please remember to download and print your updated ticket. <strong>Entry will not be allowed on an unbooked day differing from that indicated on the ticket.</strong>',
        },
        { ...htmlParserOptions }
      ),
      backButton: intl.formatMessage({
        description: 'edit mytickets page back button',
        defaultMessage: 'Back',
      }),
      dialog: {
        titleDelete: intl.formatMessage({
          description: 'Tickets dialog action edit my ticket title',
          defaultMessage: 'EDIT DATE',
        }),
        subtitleDelete: intl.formatMessage({
          description: 'Tickets dialog action edit my ticket subtitle',
          defaultMessage: 'Are you sure you want to change the date?',
        }),
        textDelete: intl.formatMessage({
          description: 'Tickets dialog action edit my ticket text',
          defaultMessage:
            'If you change dates, your previous ticket will no longer be valid. Remember to print out your new ticket.',
        }),
        btn: {
          cancel: intl.formatMessage({
            description: 'Tickets dialog action edit my ticket btn cancel',
            defaultMessage: 'Cancel',
          }),
          delete: intl.formatMessage({
            description: 'Tickets dialog action edit my ticket btn ok',
            defaultMessage: 'OK',
          }),
        },
      },
      card: {
        ticket: intl.formatMessage({
          description: 'my tickets edit quantity label',
          defaultMessage: 'Ticket',
        }),
        date: intl.formatMessage({
          description: 'my tickets edit date label',
          defaultMessage: 'Date',
        }),
        edit: intl.formatMessage({
          description: 'my tickets edit card edit',
          defaultMessage: 'Edit Date',
        }),
        selectedDate: intl.formatMessage({
          description: 'my tickets edit selected date',
          defaultMessage: 'Selected Date',
        }),
        selectedNewDate: intl.formatMessage({
          description: 'my tickets edit selected new date',
          defaultMessage: 'Selected New Date',
        }),
        notify: {
          label: intl.formatMessage({
            description: 'notify edit myticket label',
            defaultMessage: 'Send mail to owner',
          }),
        },
        owner_flag_privacy_2: {
          label: intl.formatMessage({
            description: 'privacy 2 edit myticket label',
            defaultMessage:
              'I hereby provide my consent to the processing of my personal data for the receipt of marketing communications.',
          }),
        },
        owner_flag_privacy_3: {
          label: intl.formatMessage({
            description: 'privacy 3 edit myticket label',
            defaultMessage:
              'I hereby provide my consent to the processing of my personal data for profiling purpose and for analysis of consumption habits.',
          }),
        },
        owner_flag_privacy_4: {
          label: intl.formatMessage({
            description: 'privacy 4 edit myticket label',
            defaultMessage:
              'I hereby provide my consent to the transfer of my personal data to third parties.',
          }),
        },
        btn: {
          cancel: intl.formatMessage({
            description: 'cancel edit myticket btn',
            defaultMessage: 'Cancel',
          }),
          save: intl.formatMessage({
            description: 'save edit myticket btn',
            defaultMessage: 'Save',
          }),
        },
      },
    },
  }),
  Agenda: (intl) => ({
    operator: {
      title: intl.formatMessage({
        description: 'Agenda operator page title',
        defaultMessage: 'My Agenda',
      }),
      subtitle: intl.formatMessage({
        description: 'Agenda operator page subtitle',
        defaultMessage: 'Personal Area',
      }),
      appointment: intl.formatMessage({
        description: 'Agenda operator page appointment',
        defaultMessage: 'Appointment',
      }),
      noAppointment: intl.formatMessage({
        description: 'Agenda operator page noAppointment',
        defaultMessage: 'No appointments',
      }),
      noAppointmentMsg: intl.formatMessage({
        description: 'Agenda operator page noAppointmentMsg',
        defaultMessage: `You don't have any appointments in your diary`,
      }),
      view: intl.formatMessage({
        description: 'Agenda operator page view',
        defaultMessage: 'View',
      }),
      pending: intl.formatMessage({
        description: 'Agenda operator page pending',
        defaultMessage: 'Waiting',
      }),
      confirmed: intl.formatMessage({
        description: 'Agenda operator page confirmed',
        defaultMessage: 'Confirmed',
      }),
      addToCalendar: intl.formatMessage({
        description: 'Agenda operator page addToCalendar',
        defaultMessage: 'Add to calendar',
      }),
      fields: {
        addToCalendar: intl.formatMessage({
          description: 'Agenda operator page fields calendar',
          defaultMessage: 'Add to calendar',
        }),
        referent: intl.formatMessage({
          description: 'Agenda operator page fields referent',
          defaultMessage: 'Referent',
        }),
        pending: intl.formatMessage({
          description: 'Agenda operator page fields pending',
          defaultMessage: 'Waiting',
        }),
        confirmed: intl.formatMessage({
          description: 'Agenda operator page fields confirmed',
          defaultMessage: 'Confirmed',
        }),
        day: intl.formatMessage({
          description: 'Agenda operator page fields day',
          defaultMessage: 'Visit day',
        }),
        time: intl.formatMessage({
          description: 'Agenda operator page fields time',
          defaultMessage: 'Visit time',
        }),
        stand: intl.formatMessage({
          description: 'Agenda operator page fields stand',
          defaultMessage: 'Stand',
        }),
        pavillion: intl.formatMessage({
          description: 'Agenda operator page fields pavillion',
          defaultMessage: 'Pavillion',
        }),
        status: intl.formatMessage({
          description: 'Agenda operator page fields status',
          defaultMessage: 'Status',
        }),
        deldelete: intl.formatMessage({
          description: 'Agenda operator page fields delete',
          defaultMessage: 'Delete',
        }),
        back: intl.formatMessage({
          description: 'Agenda operator page fields back',
          defaultMessage: 'Back',
        }),
        brand: intl.formatMessage({
          description: 'Agenda operator fields brand',
          defaultMessage: 'Brand',
        }),
        appointment: intl.formatMessage({
          description: 'Agenda operator fields appointment',
          defaultMessage: 'Appointment',
        }),
      },
    },
    forms: {
      notOperator: intl.formatMessage({
        description: 'Agenda forms booking brandTitle notOperator',
        defaultMessage:
          'We are sorry, only operators can book an appointment with an exhibitor',
      }),
      error: intl.formatMessage({
        description: 'Agenda forms booking brandTitle error',
        defaultMessage: 'Something went wrong, please try again later.',
      }),
      noVisits: intl.formatMessage({
        description: 'Agenda forms booking brandTitle noVisits',
        defaultMessage: 'has no free slots',
      }),
      brand: {
        title: intl.formatMessage({
          description: 'Agenda forms booking brandTitle',
          defaultMessage: 'Booking request',
        }),
        subtitle: intl.formatMessage({
          description: 'Agenda forms booking brandsubtitle',
          defaultMessage: 'Personal Area',
        }),
        dialogTitleBrand: intl.formatMessage({
          description: 'Agenda forms booking dialogTitleBrand',
          defaultMessage: `Booking confirmed!`,
        }),
        dialogTitleBrandConfirm: intl.formatMessage({
          description: 'Agenda forms booking dialogTitleBrandconfirm',
          defaultMessage: `Your guest will receive an email with details of the reservation.`,
        }),
        dialogTitleBrandDeclined: intl.formatMessage({
          description: 'Agenda forms booking dialogTitleBrand declined',
          defaultMessage: `You have declined the request!`,
        }),
        dialogErrorTitle: intl.formatMessage({
          description: 'Agenda forms booking error brand dialogTitle',
          defaultMessage: `An error occured`,
        }),
        dialogErrorSubtitleOne: intl.formatMessage({
          description: 'Agenda forms booking brand dialogErrorSubtitleOne',
          defaultMessage: `Please, try again later.`,
        }),
        buttons: {
          back: intl.formatMessage({
            description: 'Agenda forms booking brands buttons back',
            defaultMessage: 'Back',
          }),
          ok: intl.formatMessage({
            description: 'Agenda forms booking brands buttons ok',
            defaultMessage: 'Ok',
          }),
        },
      },
      user: {
        title: intl.formatMessage({
          description: 'Agenda forms booking usertitle',
          defaultMessage: 'Booking',
        }),
        dialogTitle: intl.formatMessage({
          description: 'Agenda forms booking dialogTitle',
          defaultMessage: `You've sent your request!`,
        }),
        dialogErrorTitle: intl.formatMessage({
          description: 'Agenda forms booking error dialogTitle',
          defaultMessage: `An error occured`,
        }),
        dialogSubtitleOne: intl.formatMessage({
          description: 'Agenda forms booking dialogSubtitleOne',
          defaultMessage: `Thank you for reaching us.`,
        }),
        dialogErrorSubtitleOne: intl.formatMessage({
          description: 'Agenda forms booking dialogErrorSubtitleOne',
          defaultMessage: `Please, try again later.`,
        }),
        dialogSubtitleTwo: intl.formatMessage({
          description: 'Agenda forms booking dialogSubtitleTwo',
          defaultMessage: `We received your contact request and we will be back to you soon.`,
        }),
        buttons: {
          back: intl.formatMessage({
            description: 'Agenda forms booking buttons back',
            defaultMessage: 'Back',
          }),
          ok: intl.formatMessage({
            description: 'Agenda forms booking buttons ok',
            defaultMessage: 'Ok',
          }),
        },
      },
      userSettings: intl.formatMessage({
        description: 'Agenda forms booking userSettings',
        defaultMessage: 'Booking Settings',
      }),
      fields: {
        languages: {
          it: intl.formatMessage({
            description: 'Agenda forms booking fields languages it',
            defaultMessage: 'Italian',
          }),
          en: intl.formatMessage({
            description: 'Agenda forms booking fields languages en',
            defaultMessage: 'English',
          }),
          fr: intl.formatMessage({
            description: 'Agenda forms booking fields languages fr',
            defaultMessage: 'French',
          }),
          ru: intl.formatMessage({
            description: 'Agenda forms booking fields languages ru',
            defaultMessage: 'Russian',
          }),
          ch: intl.formatMessage({
            description: 'Agenda forms booking fields languages ch',
            defaultMessage: 'Chinese',
          }),
          de: intl.formatMessage({
            description: 'Agenda forms booking fields languages de',
            defaultMessage: 'Deutsch',
          }),
        },
        error: intl.formatMessage({
          description: 'Agenda forms booking fields error',
          defaultMessage: 'Field Required',
        }),
        givenName: intl.formatMessage({
          description: 'Agenda forms booking fields givenName',
          defaultMessage: 'First Name',
        }),
        familyName: intl.formatMessage({
          description: 'Agenda forms booking fields familyName',
          defaultMessage: 'Last Name',
        }),
        email: intl.formatMessage({
          description: 'Agenda forms booking fields email',
          defaultMessage: 'Email',
        }),
        phone: intl.formatMessage({
          description: 'Agenda forms booking fields Phone',
          defaultMessage: 'Phone',
        }),
        language: intl.formatMessage({
          description: 'Agenda forms booking fields Nation',
          defaultMessage: 'Language',
        }),
        profile: intl.formatMessage({
          description: 'Agenda forms booking fields Profile',
          defaultMessage: 'Profile',
        }),
        company: intl.formatMessage({
          description: 'Agenda forms booking fields company',
          defaultMessage: 'Company/Studio name',
        }),
        role: intl.formatMessage({
          description: 'Agenda forms booking fields role',
          defaultMessage: 'Role',
        }),
        status: intl.formatMessage({
          description: 'Agenda forms booking fields status',
          defaultMessage: 'Status',
        }),
        request: intl.formatMessage({
          description: 'Agenda forms booking fields request',
          defaultMessage: 'request',
        }),
        pending: intl.formatMessage({
          description: 'Agenda forms booking fields pending',
          defaultMessage: 'Waiting',
        }),
        confirmed: intl.formatMessage({
          description: 'Agenda forms booking fields confirmed',
          defaultMessage: 'Confirmed',
        }),
        check: intl.formatMessage({
          description: 'Agenda forms booking fields check',
          defaultMessage: 'Checked-In',
        }),
        stand: intl.formatMessage({
          description: 'Agenda forms booking fields stand',
          defaultMessage: 'Stand',
        }),
        pavillion: intl.formatMessage({
          description: 'Agenda forms booking fields pavillion',
          defaultMessage: 'Pavillion',
        }),
        date: intl.formatMessage({
          description: 'Agenda forms booking fields date',
          defaultMessage: 'Visit day',
        }),
        time: intl.formatMessage({
          description: 'Agenda forms booking fields time',
          defaultMessage: 'Visit time',
        }),
        reason: intl.formatMessage({
          description: 'Agenda forms booking fields reason',
          defaultMessage: 'Reason for appointment',
        }),
        reasonUser: intl.formatMessage({
          description: 'Agenda forms booking fields reasonUser',
          defaultMessage: 'Write the reason for your appointment',
        }),
        chooseCommercial: intl.formatMessage({
          description: 'Agenda forms booking fields chooseCommercial',
          defaultMessage: 'Choose commercial referent',
        }),
        brand: intl.formatMessage({
          description: 'Agenda forms booking fields brand',
          defaultMessage: 'Brand',
        }),
        buttons: {
          delete: intl.formatMessage({
            description: 'Agenda forms booking fields buttons delete',
            defaultMessage: 'Decline',
          }),
          confirm: intl.formatMessage({
            description: 'Agenda forms booking fields buttons confirm',
            defaultMessage: 'Confirm',
          }),
          send: intl.formatMessage({
            description: 'Agenda forms booking fields buttons send',
            defaultMessage: 'Send Request',
          }),
          sendCustomRequest: intl.formatMessage({
            description:
              'Agenda forms booking fields buttons sendCustomRequest',
            defaultMessage: 'Confirm request',
          }),
          back: intl.formatMessage({
            description: 'Agenda forms booking fields buttons back',
            defaultMessage: 'Back',
          }),
        },
      },
    },
    agenda: {
      page: {
        title: intl.formatMessage({
          description: 'Agenda salesTeam page agenda title',
          defaultMessage: 'Agenda',
        }),
        // subtitle: intl.formatMessage({
        //   description: 'Agenda salesTeam page agenda subtitle',
        //   defaultMessage: 'Personal Area',
        // }),
        text: intl.formatMessage({
          description: 'Agenda salesTeam page agenda text',
          defaultMessage: 'Create and manage appointment requests',
        }),
        textWithBrand: intl.formatMessage({
          description: 'Agenda salesTeam page agenda textWithBrand',
          defaultMessage:
            'Crea e gestisci gli slot orari per gli appuntamenti e le richieste ricevute dal brand',
        }),
        noVisit: intl.formatMessage({
          description: 'Agenda salesTeam page agenda noVisit',
          defaultMessage: 'No appointments  found',
        }),
        addMsg: intl.formatMessage({
          description: 'Agenda salesTeam page agenda addMsg',
          defaultMessage: 'Create a slot to organise your agenda at the fair',
        }),
        btn: intl.formatMessage({
          description: 'Agenda salesTeam page agenda btn',
          defaultMessage: 'Create',
        }),
        buttons: {
          slot: intl.formatMessage({
            description: 'Agenda salesTeam page agenda buttons slot',
            defaultMessage: 'Slot',
          }),
          request: intl.formatMessage({
            description: 'Agenda salesTeam page agenda buttons request',
            defaultMessage: 'Booking request',
          }),
        },
        searchTextfield: intl.formatMessage({
          description: 'Agenda salesTeam page agenda searchTextfield',
          defaultMessage: 'Search',
        }),
        cards: {
          am: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card am',
            defaultMessage: 'a.m',
          }),
          pm: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card pm',
            defaultMessage: 'p.m',
          }),
          add: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card add',
            defaultMessage: 'Add Slot',
          }),
          removeSelected: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card removeSelected',
            defaultMessage: 'Remove Selected Slots',
          }),
          slot: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card slot',
            defaultMessage: 'Slot',
          }),
          confirmed: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card confirmed',
            defaultMessage: 'confirmed',
          }),
          pending: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card pending',
            defaultMessage: 'waiting',
          }),
          view: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card View',
            defaultMessage: 'View',
          }),
          delete: intl.formatMessage({
            description: 'Agenda salesTeam page agenda card Delete',
            defaultMessage: 'Delete',
          }),
        },
        bookingCards: {
          request: intl.formatMessage({
            description: 'Agenda salesTeam page agenda requestcard request',
            defaultMessage: 'request',
          }),
          confirmed: intl.formatMessage({
            description: 'Agenda salesTeam page agenda requestcard confirmed',
            defaultMessage: 'confirmed',
          }),
          checkedIn: intl.formatMessage({
            description: 'Agenda salesTeam page agenda requestcard checkedIn',
            defaultMessage: 'checked-in',
          }),
          available: intl.formatMessage({
            description: 'Agenda salesTeam page agenda requestcard available',
            defaultMessage: 'Available slots',
          }),
          buttons: {
            view: intl.formatMessage({
              description:
                'Agenda salesTeam page agenda requestcard buttons view',
              defaultMessage: 'View',
            }),
            add: intl.formatMessage({
              description: 'Agenda salesTeam page agenda requestcard add',
              defaultMessage: 'Add referent',
            }),
            delete: intl.formatMessage({
              description: 'Agenda salesTeam page agenda requestcard delete',
              defaultMessage: 'Delete',
            }),
            check: intl.formatMessage({
              description: 'Agenda salesTeam page agenda requestcard checkIn',
              defaultMessage: 'Check in',
            }),
          },
        },
        dialogs: {
          settingsGreyBox: {
            title: intl.formatMessage({
              description: 'Agenda page agenda dialog settingsGreyBox title',
              defaultMessage: 'Le tue impostazioni',
            }),
            prenotazione_appuntamenti: intl.formatMessage({
              description:
                'Agenda page agenda dialog settingsGreyBox prenotazione_appuntamenti',
              defaultMessage: 'La funzionalità di richiesta appuntamento è',
            }),
            prenotazione_appuntamentiOn: intl.formatMessage({
              description:
                'Agenda page agenda dialog settingsGreyBox prenotazione_appuntamentiOn',
              defaultMessage: 'attiva',
            }),
            prenotazione_appuntamentiOff: intl.formatMessage({
              description:
                'Agenda page agenda dialog settingsGreyBox prenotazione_appuntamentiOff',
              defaultMessage: 'disattiva',
            }),
            email: intl.formatMessage({
              description: 'Agenda page agenda dialog settingsGreyBox email',
              defaultMessage:
                'La mail a cui arrivano le richieste di appuntamento è:',
            }),
            btn: intl.formatMessage({
              description: 'Agenda page agenda dialog settingsGreyBox btn',
              defaultMessage: 'Modifica le tue impostazioni',
            }),
          },
          settings: {
            title: intl.formatMessage({
              description: 'Agenda page agenda dialog settings title',
              defaultMessage: 'Impostazioni per le richieste di appuntamento',
            }),
            email: {
              title: intl.formatMessage({
                description: 'Agenda page agenda dialog settings email title',
                defaultMessage: 'Notifiche email',
              }),
              subOne: intl.formatMessage({
                description: 'Agenda page agenda dialog settings email subOne',
                defaultMessage:
                  'In questo momento le richieste di appuntamento arrivano a',
              }),
              subTwo: intl.formatMessage({
                description: 'Agenda page agenda dialog settings email subTwo',
                defaultMessage: 'Puoi inserire in autonomia una mail dedicata:',
              }),
              placeholder: intl.formatMessage({
                description:
                  'Agenda page agenda dialog settings email placeholder',
                defaultMessage: 'Nuovo indirizzo email',
              }),
            },
            prenotazione_appuntamenti: {
              title: intl.formatMessage({
                description:
                  'Agenda page agenda dialog settings prenotazione_appuntamenti title',
                defaultMessage: 'Richieste di appuntamento',
              }),
              sub: intl.formatMessage({
                description:
                  'Agenda page agenda dialog settings prenotazione_appuntamenti sub',
                defaultMessage:
                  'Puoi scegliere in autonomia se abilitare o disabilitare le richieste:',
              }),
              optOne: intl.formatMessage({
                description:
                  'Agenda page agenda dialog settings prenotazione_appuntamenti optOne',
                defaultMessage: 'Abilita le richieste',
              }),
              optTwo: intl.formatMessage({
                description:
                  'Agenda page agenda dialog settings prenotazione_appuntamenti optTwo',
                defaultMessage: 'Disabilita le richieste',
              }),
            },
            save: intl.formatMessage({
              description: 'Agenda page agenda dialog settings save',
              defaultMessage: 'Salva',
            }),
          },
          add: {
            title: intl.formatMessage({
              description: 'Agenda page agenda dialog add title',
              defaultMessage: 'Add Slot',
            }),
            // subtitle: intl.formatMessage({
            //   description: 'Agenda page agenda dialog add subtitle',
            //   defaultMessage: 'personal area',
            // }),
            date: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialog add data label',
                defaultMessage: 'Date',
              }),
            },
            am: intl.formatMessage({
              description: 'Agenda page agenda dialog add am',
              defaultMessage: 'a.m',
            }),
            pm: intl.formatMessage({
              description: 'Agenda page agenda dialog add pm',
              defaultMessage: 'p.m',
            }),
            morningStart: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialog add field morningStart',
                defaultMessage: 'Slot start',
              }),
              error: intl.formatMessage({
                description:
                  'Agenda page agenda dialog add field morningStart error',
                defaultMessage: 'Field required',
              }),
            },
            morningEnd: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialog add field morningEnd',
                defaultMessage: 'Slot end',
              }),
              error: intl.formatMessage({
                description:
                  'Agenda page agenda dialog add field morningEnd error',
                defaultMessage: 'Field required',
              }),
            },
            invalidRange: intl.formatMessage({
              description: 'Agenda page agenda dialog add field invalid range',
              defaultMessage: 'Invalid Time Range',
            }),
            afternoonStart: {
              label: intl.formatMessage({
                description:
                  'Agenda page agenda dialog add field afternoonStart',
                defaultMessage: 'Afternoon slot start',
              }),
              error: intl.formatMessage({
                description:
                  'Agenda page agenda dialog add field afternoonStart error',
                defaultMessage: 'Field required',
              }),
            },
            afternoonEnd: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialog add field afternoonEnd',
                defaultMessage: 'Afternoon slot end',
              }),
              error: intl.formatMessage({
                description:
                  'Agenda page agenda dialog add field afternoonEnd error',
                defaultMessage: 'Field required',
              }),
            },
            slotCapacity: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialog add field capacity',
                defaultMessage: 'Number of commercials',
              }),
              error: intl.formatMessage({
                description: 'Agenda page agenda dialog add capacity error',
                defaultMessage: 'Capacity is required',
              }),
            },
            buttons: {
              cancel: intl.formatMessage({
                description: 'Agenda page agenda dialog add cancel',
                defaultMessage: 'Cancel',
              }),
              save: intl.formatMessage({
                description: 'Agenda page agenda dialog add save',
                defaultMessage: 'Save',
              }),
            },
          },
          view: {
            title: intl.formatMessage({
              description: 'Agenda page agenda dialogview title',
              defaultMessage: 'Slot',
            }),
            // subtitle: intl.formatMessage({
            //   description: 'Agenda page agenda dialogview subtitle',
            //   defaultMessage: 'personal area',
            // }),
            date: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialogview data label',
                defaultMessage: 'Date',
              }),
            },
            start: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialogview start label',
                defaultMessage: 'Start',
              }),
            },
            end: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialogview end label',
                defaultMessage: 'End',
              }),
            },
            slotCapacity: {
              label: intl.formatMessage({
                description: 'Agenda page agenda dialogview capacity label',
                defaultMessage: 'Number of commercials',
              }),
            },
          },
          delete: {
            titleDecline: intl.formatMessage({
              description: 'Agenda page agenda dialog decline title',
              defaultMessage: 'Are you sure you want to decline the request?',
            }),
            subDecline: intl.formatMessage({
              description: 'Agenda page agenda dialog decline title',
              defaultMessage:
                'By refusing the request the appointment will be canceled and your guest will receive an email with the details.',
            }),
            title: intl.formatMessage({
              description: 'Agenda page agenda dialog delete title',
              defaultMessage: 'Are you sure you want to remove the slot?',
            }),
            titleAppointment: intl.formatMessage({
              description: 'Agenda page agenda dialog delete appointment title',
              defaultMessage: 'Are you sure you want to cancel the request?',
            }),
            // subtitle: intl.formatMessage({
            //   description: 'Agenda page agenda dialog delete subtitle',
            //   defaultMessage: 'personal area',
            // }),
            titleMyAgenda: intl.formatMessage({
              description: 'Agenda page agenda dialog delete titleMyAgenda',
              defaultMessage:
                'Are you sure you want to remove the reservation?',
            }),
            subMyAgenda: intl.formatMessage({
              description: 'Agenda page agenda dialog delete subMyAgenda',
              defaultMessage:
                'By cancelling this reservation your appointment will be deleted.',
            }),
            textSlot: intl.formatMessage({
              description: 'Agenda page agenda dialog delete text slot',
              defaultMessage:
                'By cancelling this slot, operators will no longer be able to book at the time shown.',
            }),
            subTextSlot: intl.formatMessage({
              description: 'Agenda page agenda dialog delete subTextSlot slot',
              defaultMessage:
                'By canceling the request the appointment will be canceled and your guest will receive an email with the details.',
            }),
            subtextSingleWithVisit: intl.formatMessage({
              description:
                'Agenda page agenda dialog delete subtextSingleWithVisit',
              defaultMessage:
                'One or more appointments have been confirmed in this slot. By removing the slot all appointments will be cancelled and visitors will be notified of the cancellation.',
            }),
            subtextMultipleWithVisit: intl.formatMessage({
              description:
                'Agenda page agenda dialog delete subtextMultipleWithVisit',
              defaultMessage:
                'One or more appointments have been confirmed in these slots. By removing the slots all appointments will be cancelled and visitors will be notified of the cancellation.',
            }),
            titleMultiple: intl.formatMessage({
              description: 'Agenda page agenda dialog delete titleMultiple',
              defaultMessage: 'Are you sure you want to remove the slots?',
            }),
            subTextMultiple: intl.formatMessage({
              description: 'Agenda page agenda dialog delete subTextMultiple',
              defaultMessage:
                'By removing these slots, operators will no longer be able to book at the time shown.',
            }),
            btn: {
              cancel: intl.formatMessage({
                description: 'Agenda page agenda dialog delete cancel',
                defaultMessage: 'Cancel',
              }),
              delete: intl.formatMessage({
                description: 'Agenda page agenda dialog delete ok',
                defaultMessage: 'Delete',
              }),
              decline: intl.formatMessage({
                description: 'Agenda page agenda dialog decline ok',
                defaultMessage: 'Decline',
              }),
            },
          },
        },
      },
      create: {
        title: intl.formatMessage({
          description: 'Agenda page create title',
          defaultMessage: 'Create your visit',
        }),
        text: intl.formatMessage({
          description: 'Agenda page create text',
          defaultMessage:
            'Set days and hours dedicated to meetings with trade visitors at your stand',
        }),
        // subtitle: intl.formatMessage({
        //   description: 'Agenda page create subtitle',
        //   defaultMessage: 'Personal Area',
        // }),
        paragraph: intl.formatMessage({
          description: 'Agenda page create paragraph',
          defaultMessage: 'Stand Visits timetable',
        }),
        am: intl.formatMessage({
          description: 'Agenda page create am',
          defaultMessage: 'a.m',
        }),
        pm: intl.formatMessage({
          description: 'Agenda page create pm',
          defaultMessage: 'p.m',
        }),
        errors: intl.formatMessage({
          description: 'Agenda page create errors',
          defaultMessage:
            'Appointment must start after 9.30 a.m and finish before 6.30 p.m',
        }),
        fields: {
          date: {
            label: intl.formatMessage({
              description: 'Agenda page create field data label',
              defaultMessage: 'Select date',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field data error',
              defaultMessage: 'Date is required',
            }),
          },
          morningStart: {
            label: intl.formatMessage({
              description: 'Agenda page create field morningStart',
              defaultMessage: 'Start',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field morningStart error',
              defaultMessage: 'Field required',
            }),
          },
          morningEnd: {
            label: intl.formatMessage({
              description: 'Agenda page create field morningEnd',
              defaultMessage: 'End',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field morningEnd error',
              defaultMessage: 'Field required',
            }),
          },
          afternoonStart: {
            label: intl.formatMessage({
              description: 'Agenda page create field afternoonStart',
              defaultMessage: 'Afternoon meeting start',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field afternoonStart error',
              defaultMessage: 'Field required',
            }),
          },
          afternoonEnd: {
            label: intl.formatMessage({
              description: 'Agenda page create field afternoonEnd',
              defaultMessage: 'Afternoon meeting end',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field afternoonEnd error',
              defaultMessage: 'Field required',
            }),
          },
          slotTime: {
            label: intl.formatMessage({
              description: 'Agenda page create field time',
              defaultMessage: 'Time of single slot',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field time error',
              defaultMessage: 'Time is required',
            }),
          },
          slotCapacity: {
            label: intl.formatMessage({
              description: 'Agenda page create field capacity',
              defaultMessage: 'Number of commercials',
            }),
            error: intl.formatMessage({
              description: 'Agenda page create field capacity error',
              defaultMessage: 'Capacity is required',
            }),
          },
          minutes: intl.formatMessage({
            description: 'Agenda page create field minutes',
            defaultMessage: 'minutes',
          }),
        },
        buttons: {
          cancel: intl.formatMessage({
            description: 'Agenda page create btn cancel',
            defaultMessage: 'Cancel',
          }),
          save: intl.formatMessage({
            description: 'Agenda page create btn save',
            defaultMessage: 'Save',
          }),
          back: intl.formatMessage({
            description: 'Agenda page create btn back',
            defaultMessage: 'Back',
          }),
        },
      },
    },
    salesTeam: {
      page: {
        title: intl.formatMessage({
          description: 'Agenda salesTeam page title',
          defaultMessage: 'Sales team',
        }),
        // subtitle: intl.formatMessage({
        //   description: 'Agenda salesTeam page subtitle',
        //   defaultMessage: 'Personal Area',
        // }),
        text: intl.formatMessage({
          description: 'Agenda salesTeam page text',
          defaultMessage: 'Add your sales team contacts',
        }),
        textWithBrand: intl.formatMessage({
          description: 'Agenda salesTeam page agenda textWithBrand',
          defaultMessage: 'Aggiungi i referenti del tuo team per il brand',
        }),
        noContacts: intl.formatMessage({
          description: 'Agenda salesTeam page noContacts',
          defaultMessage: 'No contact',
        }),
        addMsg: intl.formatMessage({
          description: 'Agenda salesTeam page addMsg',
          defaultMessage: 'Add the agent to your team',
        }),
        btn: intl.formatMessage({
          description: 'Agenda salesTeam page btn',
          defaultMessage: 'Add',
        }),
        card: {
          view: intl.formatMessage({
            description: 'Agenda salesTeam page card view',
            defaultMessage: 'View',
          }),
          edit: intl.formatMessage({
            description: 'Agenda salesTeam page card edit',
            defaultMessage: 'Edit',
          }),
          delete: intl.formatMessage({
            description: 'Agenda salesTeam page card delete',
            defaultMessage: 'Delete',
          }),
        },
      },
      dialog: {
        delete: {
          title: intl.formatMessage({
            description: 'Agenda salesTeam dialog delete title',
            defaultMessage: 'Are you sure you want to remove this contact?',
          }),
          text: intl.formatMessage({
            description: 'Agenda salesTeam dialog delete text',
            defaultMessage:
              'By removing the contact all the details will be deleted',
          }),
          subtitle: intl.formatMessage({
            description: 'Agenda salesTeam dialog delete subtitle',
            defaultMessage: 'sales team',
          }),
          btn: {
            cancel: intl.formatMessage({
              description: 'Agenda salesTeam dialog btn cancel',
              defaultMessage: 'Cancel',
            }),
            ok: intl.formatMessage({
              description: 'Agenda salesTeam dialog btn ok',
              defaultMessage: 'Ok',
            }),
          },
        },
        title: intl.formatMessage({
          description: 'Agenda salesTeam dialog title',
          defaultMessage: 'Add new contact',
        }),
        readOnlyTitle: intl.formatMessage({
          description: 'Agenda salesTeam dialog readOnlytitle',
          defaultMessage: 'Referent',
        }),
        subtitle: intl.formatMessage({
          description: 'Agenda salesTeam dialog subtitle',
          defaultMessage: 'Personal Area',
        }),
        btn: {
          cancel: intl.formatMessage({
            description: 'Agenda salesTeam dialog btn cancel',
            defaultMessage: 'Cancel',
          }),
          save: intl.formatMessage({
            description: 'Agenda salesTeam dialog btn save',
            defaultMessage: 'Save',
          }),
          delete: intl.formatMessage({
            description: 'Agenda salesTeam dialog btn delete',
            defaultMessage: 'Remove',
          }),
        },
        fields: {
          languages: {
            it: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages it',
              defaultMessage: 'Italian',
            }),
            en: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages en',
              defaultMessage: 'English',
            }),
            fr: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages fr',
              defaultMessage: 'French',
            }),
            ru: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages ru',
              defaultMessage: 'Russian',
            }),
            ch: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages ch',
              defaultMessage: 'Chinese',
            }),
            de: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages de',
              defaultMessage: 'Deutsch',
            }),
          },
          email: {
            label: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields email label',
              defaultMessage: 'Email',
            }),
            error: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields email error',
              defaultMessage: 'Email is required',
            }),
          },
          givenName: {
            label: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields givenName label',
              defaultMessage: 'First Name',
            }),
            error: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields givenName error',
              defaultMessage: 'First Name is required',
            }),
          },
          familyName: {
            label: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields familyName label',
              defaultMessage: 'Last Name',
            }),
            error: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields familyName error',
              defaultMessage: 'Last Name is required',
            }),
          },
          phone: {
            label: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields phone label',
              defaultMessage: 'Phone',
            }),
            error: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields phone error',
              defaultMessage: 'Phone is required',
            }),
          },
          role: {
            label: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields role label',
              defaultMessage: 'Role',
            }),
            error: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields role error',
              defaultMessage: 'Role is required',
            }),
          },
          languagesField: {
            label: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages label',
              defaultMessage: 'Language',
            }),
            error: intl.formatMessage({
              description: 'Agenda salesTeam dialog fields languages error',
              defaultMessage: 'Language is required',
            }),
          },
        },
      },
    },
  }),
  chatPage: (intl) => ({
    channelRoutingErrors: {
      channelNotFound: intl.formatMessage({
        description: 'channel not found error message',
        defaultMessage: 'Channel not found',
      }),
      notInvited: intl.formatMessage({
        description: 'not invited error message',
        defaultMessage: 'You have not been invited to this session',
      }),
      genericError: intl.formatMessage({
        description: 'channel not found error message',
        defaultMessage: 'Error',
      }),
    },
    loadMoreContent: intl.formatMessage({
      description: 'load more messages',
      defaultMessage: 'Load older messages',
    }),
    back: intl.formatMessage({
      description: 'back',
      defaultMessage: 'Back',
    }),
    messages: {
      youTranslation: intl.formatMessage({
        description: '"you" label on message',
        defaultMessage: 'You',
      }),
    },
    bannedError: intl.formatMessage({
      description: 'banned error placeholder',
      defaultMessage: 'Chat disabled for your user',
    }),
    expiredError: intl.formatMessage({
      description: 'expired error placeholder',
      defaultMessage: 'This Live Chat Session is expired',
    }),
    serviceMessages: {
      webinarJoin: {
        label: intl.formatMessage({
          description: 'social service message join',
          defaultMessage: 'joined the webinar',
        }),
      },
      webinarLeave: {
        label: intl.formatMessage({
          description: 'social service message leave',
          defaultMessage: 'left the webinar',
        }),
      },
    },
    usersTab: {
      ban: intl.formatMessage({
        description: 'ban user tooltip message',
        defaultMessage: 'Ban user',
      }),
      unban: intl.formatMessage({
        description: 'unban user tooltip message',
        defaultMessage: 'Unban user',
      }),
      bannedUser: intl.formatMessage({
        description: 'bannedUser status text',
        defaultMessage: 'banned',
      }),
      noVipOnline: intl.formatMessage({
        description: 'no vip users connected message',
        defaultMessage: 'No speakers connected',
      }),
      noUserOnline: intl.formatMessage({
        description: 'no users connected message',
        defaultMessage: 'No users connected',
      }),
      invitedUsers: intl.formatMessage({
        description: 'user list message',
        defaultMessage: 'Community',
      }),
      vipOnline: intl.formatMessage({
        description: 'bannedUser status text',
        defaultMessage: 'Speakers',
      }),
      speakers: intl.formatMessage({
        description: 'speakers title text',
        defaultMessage: 'Speakers',
      }),
      tabs: {
        info: intl.formatMessage({
          description: 'info tab text',
          defaultMessage: 'Info',
        }),
        participants: intl.formatMessage({
          description: 'participants tab text',
          defaultMessage: 'Participants',
        }),
      },
    },
    moderator: {
      deleteMessage: intl.formatMessage({
        description: 'moderator delete message',
        defaultMessage: 'Message is inappropriate',
      }),
      buttons: {
        ban: intl.formatMessage({
          description: 'moderator ban button',
          defaultMessage: 'Ban User',
        }),
        delete: intl.formatMessage({
          description: 'moderator delete button',
          defaultMessage: 'Delete Message',
        }),
        moderated: intl.formatMessage({
          description: 'moderated tooltip text',
          defaultMessage: 'Moderated',
        }),
      },
    },
    messageInput: {
      placeholder: intl.formatMessage({
        description: 'chat input placeholder',
        defaultMessage: 'Write your message here...',
      }),
      emojiPicker: {
        title: intl.formatMessage({
          description: 'emoji picker title',
          defaultMessage: 'Pick your emoji...',
        }),
        i18n: {
          search: intl.formatMessage({
            description: 'emoji picker search',
            defaultMessage: 'Search',
          }),
          clear: intl.formatMessage({
            description: 'emoji picker clear',
            defaultMessage: 'Clear',
          }),
          notfound: intl.formatMessage({
            description: 'emoji picker not found',
            defaultMessage: 'No Emoji Found',
          }),
          skintext: intl.formatMessage({
            description: 'emoji picker skin text',
            defaultMessage: 'Choose your default skin tone',
          }),
          categories: {
            search: intl.formatMessage({
              description: 'emoji picker categories search',
              defaultMessage: 'Search Results',
            }),
            recent: intl.formatMessage({
              description: 'emoji picker categories recent',
              defaultMessage: 'Frequently Used',
            }),
            smileys: intl.formatMessage({
              description: 'emoji picker categories smileys',
              defaultMessage: 'Smileys & Emotion',
            }),
            people: intl.formatMessage({
              description: 'emoji picker categories people',
              defaultMessage: 'People & Body',
            }),
            nature: intl.formatMessage({
              description: 'emoji picker categories nature',
              defaultMessage: 'Animals & Nature',
            }),
            foods: intl.formatMessage({
              description: 'emoji picker categories foods',
              defaultMessage: 'Food & Drink',
            }),
            activity: intl.formatMessage({
              description: 'emoji picker categories activity',
              defaultMessage: 'Activity',
            }),
            places: intl.formatMessage({
              description: 'emoji picker categories places',
              defaultMessage: 'Travel & Places',
            }),
            objects: intl.formatMessage({
              description: 'emoji picker categories objects',
              defaultMessage: 'Objects',
            }),
            symbols: intl.formatMessage({
              description: 'emoji picker categories symbols',
              defaultMessage: 'Symbols',
            }),
            flags: intl.formatMessage({
              description: 'emoji picker categories flags',
              defaultMessage: 'Flags',
            }),
            custom: intl.formatMessage({
              description: 'emoji picker categories custom',
              defaultMessage: 'Custom',
            }),
          },
          categorieslabel: intl.formatMessage({
            description: 'emoji picker categories label',
            defaultMessage: 'Emoji categories',
          }),
          skintones: {
            1: intl.formatMessage({
              description: 'emoji picker default skin tone',
              defaultMessage: 'Default Skin Tone',
            }),
            2: intl.formatMessage({
              description: 'emoji picker light skin tone',
              defaultMessage: 'Light Skin Tone',
            }),
            3: intl.formatMessage({
              description: 'emoji picker medium-light skin tone',
              defaultMessage: 'Medium-Light Skin Tone',
            }),
            4: intl.formatMessage({
              description: 'emoji picker medium skin tone',
              defaultMessage: 'Medium Skin Tone',
            }),
            5: intl.formatMessage({
              description: 'emoji picker medium-dark skin tone',
              defaultMessage: 'Medium-Dark Skin Tone',
            }),
            6: intl.formatMessage({
              description: 'emoji picker dark skin tone',
              defaultMessage: 'Dark Skin Tone',
            }),
          },
        },
      },
      error: {
        label: intl.formatMessage({
          description: 'chat message input error',
          defaultMessage: 'Error, try again',
        }),
      },
      send: {
        label: intl.formatMessage({
          description: 'chat input send',
          defaultMessage: 'SEND',
        }),
      },
    },
  }),
  productPage: (intl) => ({
    tooltip: {
      sliderHover: intl.formatMessage({
        description: 'tooltip sliderHover',
        defaultMessage: 'Drag the image to change the order',
      }),
      errorChar: intl.formatMessage({
        description: 'tooltip errorChar',
        defaultMessage: 'The content is above the allowed limit',
      }),
      errorTranslate: intl.formatMessage({
        description: 'tooltip errorTranslate',
        defaultMessage:
          'This component can only be modified from the Italian page',
      }),
      characters: intl.formatMessage({
        description: 'tooltip Characters',
        defaultMessage: 'Characters',
      }),
    },
    descriptionsAdditionalContents: {
      designer: intl.formatMessage({
        description: 'descriptionsAdditionalContents designer',
        defaultMessage:
          'This module allows you to enter the name and a photo of the designer who developed the product.',
      }),
      vimeo_video: intl.formatMessage({
        description: 'descriptionsAdditionalContents vimeo_video',
        defaultMessage:
          'This module allows you to add a Vimeo video to your page.',
      }),
      youtube_video: intl.formatMessage({
        description: 'descriptionsAdditionalContents youtube_video',
        defaultMessage:
          'This module allows you to add a YouTube video to your page.',
      }),
      virtual_showroom: intl.formatMessage({
        description: 'descriptionsAdditionalContents virtual_showroom',
        defaultMessage:
          'This module allows you to add a 3D rendering of your showroom to your page.',
      }),
    },
    info: {
      cropper: {
        title: intl.formatMessage({
          description: 'productPage info TRANSLATE Cropper title',
          defaultMessage: 'Resize Image',
        }),
        body: intl.formatMessage({
          description: 'productPage info TRANSLATE Cropper body',
          defaultMessage:
            'Place the rectangle over the area of the image you want to publish on the page, and click on the OK button.',
        }),
        preview: intl.formatMessage({
          description: 'productPage info Cropper preview',
          defaultMessage: 'Preview',
        }),
        next: intl.formatMessage({
          description: 'productPage info Cropper next',
          defaultMessage: 'Next',
        }),
        prev: intl.formatMessage({
          description: 'productPage info Cropper next',
          defaultMessage: 'Prev',
        }),
      },
      preview: {
        title: intl.formatMessage({
          description: 'productPage info preview title',
          defaultMessage: 'Info',
        }),
      },
      language: {
        title: intl.formatMessage({
          description: 'productPage info language title',
          defaultMessage: 'Add Product',
        }),
        body: intl.formatMessage({
          description: 'productPage info language body',
          defaultMessage:
            'You are creating the page for the Italian section of the platform. Please fill in at least the required fields before saving. The first time you save it, the page for the English section will also be created automatically. If necessary, you can enter the English text also for the Italian section.',
        }),
      },
      beforseSave: {
        title: intl.formatMessage({
          description: 'productPage info beforeSave title',
          defaultMessage: 'Save',
        }),
        body: intl.formatMessage({
          description: 'productPage info beforeSave body',
          defaultMessage:
            'If you save, the page for the English section of the platform will also be automatically created. We recommend that you enter all the contents of the page before leaving the input interface, so that the pages of both sections will be complete with all the information.',
        }),
      },
      beforeApprovation: {
        title: intl.formatMessage({
          description: 'productPage info save title',
          defaultMessage: 'Submit for approval',
        }),
        body: intl.formatMessage({
          description: 'productPage info beforeSave body',
          defaultMessage:
            'Are you sure you want to submit the page? You will not be able to modify it until approval',
        }),
      },
      save: {
        title: intl.formatMessage({
          description: 'productPage info save title',
          defaultMessage: 'Back to list of content',
        }),
        body: intl.formatMessage({
          description: 'productPage info save body',
          defaultMessage:
            'Returning to the List of contents will not save your changes. Choose how to proceed:',
        }),
        agree: intl.formatMessage({
          description: 'productPage info save agree',
          defaultMessage: 'Back to list',
        }),
        options: {
          save: intl.formatMessage({
            description: 'productPage info save options save',
            defaultMessage: 'Save and return to List of contents',
          }),
          doNotSave: intl.formatMessage({
            description: 'productPage info save options doNotSave',
            defaultMessage: 'Return to List of contents without saving',
          }),
        },
      },
      translate: {
        title: intl.formatMessage({
          description: 'productPage info translate title',
          defaultMessage: 'Switch language',
        }),
        body: intl.formatMessage({
          description: 'productPage info translate body',
          defaultMessage:
            'If you switch language without saving, all changes will be lost.',
        }),
        agree: intl.formatMessage({
          description: 'productPage info translate agree',
          defaultMessage: 'Confirm',
        }),
        options: {
          save: intl.formatMessage({
            description: 'productPage info translate options save',
            defaultMessage: 'Save and switch language.',
          }),
          doNotSave: intl.formatMessage({
            description: 'productPage info translate options doNotSave',
            defaultMessage: 'Switch language without saving.',
          }),
        },
      },
    },
    errors: {
      width: {
        title: intl.formatMessage({
          description: 'productPage errors width title',
          defaultMessage: 'File size error',
        }),
        body: intl.formatMessage({
          description: 'productPage errors width body',
          defaultMessage: 'Uploaded images must have a size of',
        }),
        bodyBetween: intl.formatMessage({
          description: 'productPage errors width body between',
          defaultMessage: 'Uploaded images must have a size between',
        }),
        bodyBetweenAnd: intl.formatMessage({
          description: 'productPage errors width body between and',
          defaultMessage: 'and',
        }),
        minHeight: intl.formatMessage({
          description: 'productPage errors minHeight',
          defaultMessage: 'Uploaded images must have at least an height of',
        }),
      },
      format: {
        title: intl.formatMessage({
          description: 'productPage errors format title',
          defaultMessage: 'File format error',
        }),
        body: intl.formatMessage({
          description: 'productPage errors format body',
          defaultMessage: 'Uploaded images must be of format',
        }),
      },
      maxSize: {
        title: intl.formatMessage({
          description: 'productPage errors maxSize title',
          defaultMessage: 'File max size error',
        }),
        body: intl.formatMessage({
          description: 'productPage errors maxSize body',
          defaultMessage: 'Uploaded images must have a max size of',
        }),
      },
      required: {
        title: intl.formatMessage({
          description: 'productPage errors required title',
          defaultMessage: 'Missing required fields',
        }),
        body: intl.formatMessage({
          description: 'productPage errors required body',
          defaultMessage:
            'Before saving, all required content must be provided. The following fields are required: ',
        }),
      },
      urlFormat: {
        title: intl.formatMessage({
          description: 'productPage errors urlFormat title',
          defaultMessage: 'Format Error',
        }),
        body: intl.formatMessage({
          description: 'productPage errors urlFormat body',
          defaultMessage:
            'Error in Data Sheet: site components must be specified as an external URL, such as http://example.com',
        }),
      },
      linkError: {
        title: intl.formatMessage({
          description: 'productPage errors linkError title',
          defaultMessage: 'Format Error',
        }),
        body: intl.formatMessage({
          description: 'productPage errors linkError body',
          defaultMessage:
            'Error in Social links: site components must be specified as an external URL, such as http://example.com',
        }),
      },
      generalError: {
        title: intl.formatMessage({
          description: 'productPage errors general Error title',
          defaultMessage: 'Error',
        }),
        body: intl.formatMessage({
          description: 'productPage errors general Error body',
          defaultMessage: 'Something went wrong, please try again later',
        }),
      },
      requiredElements: {
        productName: intl.formatMessage({
          description: 'productPage errors requiredElements productName',
          defaultMessage: 'Product Name',
        }),
        brandName: intl.formatMessage({
          description: 'productPage errors requiredElements brandName',
          defaultMessage: 'Brand Name',
        }),
      },
    },
    buttons: {
      yesRadio: intl.formatMessage({
        description: 'yes',
        defaultMessage: 'Yes',
      }),
      noRadio: intl.formatMessage({
        description: 'no',
        defaultMessage: 'No',
      }),
      alt: intl.formatMessage({
        description: 'alt button - T',
        defaultMessage: 'Alternative text',
      }),
      altPlaceholder: intl.formatMessage({
        description: 'alt button place - T',
        defaultMessage: 'Enter here the alternative text',
      }),
      altDescription: intl.formatMessage({
        description: 'alt button descr - T',
        defaultMessage:
          'Enter as alt text "Brand Name - Product Name" which will appear if the image fails to load',
      }),
      chooseFile: intl.formatMessage({
        description: 'choose file - T',
        defaultMessage: 'Choose file',
      }),
      notIntFile: intl.formatMessage({
        description: 'not int file - T',
        defaultMessage: 'This image can only be modified from the Italian page',
      }),
      chooseFileSubOne: intl.formatMessage({
        description: 'choose file sub one - T',
        defaultMessage: 'Drop file here or',
      }),
      chooseFileSubTwo: intl.formatMessage({
        description: 'choose file sub two - T',
        defaultMessage: 'choose a file',
      }),
      chooseFileSubThree: intl.formatMessage({
        description: 'choose file sub three - T',
        defaultMessage: 'from your device',
      }),
      back: intl.formatMessage({
        description: 'back to list button - T',
        defaultMessage: 'Back to list of contents',
      }),
      preview: intl.formatMessage({
        description: 'preview button - T',
        defaultMessage: 'Preview',
      }),
      previewTooltip: intl.formatMessage({
        description: 'preview Tooltip',
        defaultMessage: 'preview Tooltip',
      }),
      save: intl.formatMessage({
        description: 'save button - T',
        defaultMessage: 'Save',
      }),
      translate: intl.formatMessage({
        description: 'translate - T',
        defaultMessage: 'Translate',
      }),
      goToIt: intl.formatMessage({
        description: 'translate go to it - T',
        defaultMessage: 'Go to ITA',
      }),
      goToEn: intl.formatMessage({
        description: 'translate go to en - T',
        defaultMessage: 'Go to ENG',
      }),
      publish: intl.formatMessage({
        description: 'publish button',
        defaultMessage: 'Publish',
      }),
      approval: intl.formatMessage({
        description: 'send for approval - T',
        defaultMessage: 'Submit for approval',
      }),
      language: intl.formatMessage({
        description: 'language inoput',
        defaultMessage: 'Language',
      }),
      edit: intl.formatMessage({
        description: 'edit page button',
        defaultMessage: 'Edit page',
      }),
      sdm_quoted_text: intl.formatMessage({
        description: 'add quote',
        defaultMessage: 'Add quote',
      }),
      title_section_text: intl.formatMessage({
        description: 'add title',
        defaultMessage: 'Add title',
      }),
      slider_detail: intl.formatMessage({
        description: 'add slider',
        defaultMessage: 'Add photogallery',
      }),
      technical_sheet: intl.formatMessage({
        description: 'add technical_sheet',
        defaultMessage: 'Add data sheet',
      }),
      sd_brand_multitext: intl.formatMessage({
        description: 'add text block',
        defaultMessage: 'Add text block',
      }),
      designer: intl.formatMessage({
        description: 'add designer',
        defaultMessage: 'Add designer',
      }),
      immagine_libera_full_screen: intl.formatMessage({
        description: 'add immagine_libera_full_screen',
        defaultMessage: 'Add fullscreen free image',
      }),
      virtual_showroom: intl.formatMessage({
        description: 'add virtual_showroom',
        defaultMessage: 'Add Virtual Showroom',
      }),
      free_image: intl.formatMessage({
        description: 'add free_image',
        defaultMessage: 'Add single image',
      }),
      section_title: intl.formatMessage({
        description: 'add title',
        defaultMessage: 'Add Title',
      }),
      vimeo_video: intl.formatMessage({
        description: 'add vimeo',
        defaultMessage: 'Add Vimeo videos',
      }),
      youtube_video: intl.formatMessage({
        description: 'add youtube',
        defaultMessage: 'Add YouTube videos',
      }),
    },
    titles: {
      new: intl.formatMessage({
        description: 'general information new - T',
        defaultMessage:
          'By selecting this flag, the product is categorized as "new", making it appear in the appropriate section of the product categories listing page.',
      }),
      brandDesc: intl.formatMessage({
        description: 'general information new brandDesc - T',
        defaultMessage:
          'The brand name is an automatically assigned and non-editable field',
      }),
      exposed: intl.formatMessage({
        description: 'general information exposed - T',
        defaultMessage:
          'By selecting this flag, the product is categorized as an "exhibited product" and the QR codes will be generated which, once printed, can be present at the Fair, allowing visitors to reach the product pages easily and view the information quickly.',
      }),
      previewFlag: intl.formatMessage({
        description: 'general information previewFlag - T',
        defaultMessage:
          'By selecting this flag, the product is categorized as "preview 2023", and published starting from the first day of the Fair.',
      }),
      category: intl.formatMessage({
        description: 'general information category - T',
        defaultMessage: 'Category',
      }),
      categorySub: intl.formatMessage({
        description: 'general information categorySub - T',
        defaultMessage:
          'The values entered in the categorization are used to filter the product types on the product listing page',
      }),
      generalAccordeon: intl.formatMessage({
        description: 'general information - T',
        defaultMessage: 'General Information',
      }),
      generalAccordeonSub: intl.formatMessage({
        description: 'general information sub - T',
        defaultMessage:
          'General information will not be displayed on this page',
      }),
      generalAccordeonSubBrand: intl.formatMessage({
        description: 'general information sub - T',
        defaultMessage:
          'General information will not be displayed on this page',
      }),
      basicAccordeon: intl.formatMessage({
        description: 'basic content - T',
        defaultMessage: 'Basic Content',
      }),
      basicAccordeonSub: intl.formatMessage({
        description: 'basic content sub - T',
        defaultMessage: 'Basic content items are required to create the page',
      }),
      additionalAccordeon: intl.formatMessage({
        description: 'additional content - T',
        defaultMessage: 'Additional Content',
      }),
      additionalAccordeonSub: intl.formatMessage({
        description: 'additional sub content - T',
        defaultMessage:
          'Additional content items are optional and may be included to complete the page',
      }),
      email: intl.formatMessage({
        description: 'email title',
        defaultMessage: 'EMAIL',
      }),
      logo: intl.formatMessage({
        description: 'logo title',
        defaultMessage: 'LOGO',
      }),
      brand: intl.formatMessage({
        description: 'brand',
        defaultMessage: 'BRAND',
      }),
      brandName: intl.formatMessage({
        description: 'brand name - T',
        defaultMessage: 'BRAND NAME',
      }),
      productName: intl.formatMessage({
        description: 'brand name - T',
        defaultMessage: 'PRODUCT NAME',
      }),
      coverImage: intl.formatMessage({
        description: 'cover image',
        defaultMessage: 'COVER IMAGE',
      }),
      summary: intl.formatMessage({
        description: 'summary',
        defaultMessage: 'SUMMARY',
      }),
      textBlock: intl.formatMessage({
        description: 'text block',
        defaultMessage: 'TEXT BLOCK',
      }),
      titleBlock: intl.formatMessage({
        description: 'title block',
        defaultMessage: 'TITLE BLOCK',
      }),
      blockTitle: intl.formatMessage({
        description: 'title block',
        defaultMessage: 'add Title Block',
      }),
      detailSlider: intl.formatMessage({
        description: 'detail slider',
        defaultMessage: 'PHOTOGALLERY',
      }),
      youtubeVideo: intl.formatMessage({
        description: 'youtube video',
        defaultMessage: 'YOUTUBE VIDEO',
      }),
      vimeoVideo: intl.formatMessage({
        description: ' vimeo video',
        defaultMessage: 'VIMEO VIDEO',
      }),
      virtualShowroom: intl.formatMessage({
        description: 'virtual showrrom',
        defaultMessage: 'VIRTUAL SHOWROOM',
      }),
      quote: intl.formatMessage({
        description: 'add quote',
        defaultMessage: 'QUOTE',
      }),
      designer: intl.formatMessage({
        description: 'add designer',
        defaultMessage: 'DESIGNER',
      }),
      image: intl.formatMessage({
        description: 'add image',
        defaultMessage: 'IMAGE',
      }),
      technicalSheet: intl.formatMessage({
        description: 'add technicalSheet',
        defaultMessage: 'DATA SHEET',
      }),
      fullScreenImage: intl.formatMessage({
        description: 'add fullScreenImage',
        defaultMessage: 'FULL SCREEN IMAGE',
      }),
      announcements: intl.formatMessage({
        description: 'announcements',
        defaultMessage: 'ANNOUNCEMENTS',
      }),
      preview: intl.formatMessage({
        description: 'preview',
        defaultMessage: 'PREVIEW',
      }),
      exibitedProduct: intl.formatMessage({
        description: 'exibited product',
        defaultMessage: 'EXHIBITED PRODUCT',
      }),
      url: intl.formatMessage({
        description: 'exibited url',
        defaultMessage: 'URL',
      }),
      urlText: intl.formatMessage({
        description: 'exibited urlText',
        defaultMessage: 'Link text',
      }),
    },
    inputText: {
      email: intl.formatMessage({
        description: 'insert email',
        defaultMessage: 'Enter the email here',
      }),
      foreignEmail: intl.formatMessage({
        description: 'insert foreign email',
        defaultMessage: 'Enter your foreign email here',
      }),
      selectFile: intl.formatMessage({
        description: 'select file',
        defaultMessage: 'Select file',
      }),
      insertFile: intl.formatMessage({
        description: 'insert file',
        defaultMessage: 'Drag the file here or choose a file from your device',
      }),
      insertUrl: intl.formatMessage({
        description: 'insert url',
        defaultMessage: 'Enter URL here',
      }),
      brandName: intl.formatMessage({
        description: 'brand name',
        defaultMessage: 'Brand Name',
      }),
      productName: intl.formatMessage({
        description: 'brand name - T',
        defaultMessage: 'Product Name',
      }),
      productNamePlace: intl.formatMessage({
        description: 'brand name place - T',
        defaultMessage: 'enter here the text',
      }),
      brandDesc: intl.formatMessage({
        description: 'brand desc - T',
        defaultMessage:
          'Brand name is visible on the product page and on the product list page',
      }),
    },
    imageSpecs: {
      number: intl.formatMessage({
        description: 'one file - T',
        defaultMessage: 'One File',
      }),
      size: intl.formatMessage({
        description: 'size file - T',
        defaultMessage: 'Max size:',
      }),
      format: intl.formatMessage({
        description: 'format file - T',
        defaultMessage: 'Allowed formats:',
      }),
      logoSpecSize: intl.formatMessage({
        description: 'logo spec size - T',
        defaultMessage: 'Images must have at least a size of',
      }),
      logoSpecSizeMin: intl.formatMessage({
        description: 'logo spec size min - T',
        defaultMessage: 'Images must have a size between',
      }),
      logoSpecSizeAnd: intl.formatMessage({
        description: 'logo spec size and - T',
        defaultMessage: 'and',
      }),
      coverSpecSize: intl.formatMessage({
        description: 'cover spec size - T',
        defaultMessage: 'Images must have at least a size of',
      }),
      sliderSpecSize: intl.formatMessage({
        description: 'slider spec size - T',
        defaultMessage: 'Images must be larger than',
      }),
      largerSliderSpecSize: intl.formatMessage({
        description: 'larger slider spec size - T',
        defaultMessage: 'Images larger than',
      }),
      largerSliderSpecSizeAuto: intl.formatMessage({
        description: 'larger slider spec size',
        defaultMessage: 'px will be automatically resized',
      }),
    },
    text: {
      textBlockSubtitle: intl.formatMessage({
        description: 'text block subtitle',
        defaultMessage: 'It is a long text',
      }),
      altDescription: intl.formatMessage({
        description: 'altDescription - T',
        defaultMessage:
          'Enter the brand name that will appear if the image fails to load',
      }),
      youtubeVideoSubtitle: intl.formatMessage({
        description: 'youtube subtitle',
        defaultMessage:
          'Il video Youtube sarà utilizzato per lorem ipsum dolor sit amet',
      }),
      descriptionOfVideo: intl.formatMessage({
        description: 'description of video',
        defaultMessage: 'Enter the description of the video here',
      }),
      pasteLink: intl.formatMessage({
        description: 'paste link',
        defaultMessage:
          'Paste the link copied from Youtube, as explained in the user guide for uploading content',
      }),
      mandatoryInformation: intl.formatMessage({
        description: 'mandatory information',
        defaultMessage: 'it is mandatory to fill in this information.',
      }),
    },
    introduces: intl.formatMessage({
      description: 'introduces - T',
      defaultMessage: 'INTRODUCES',
    }),
    visitBrandPage: intl.formatMessage({
      description: 'visit brand page - T',
      defaultMessage: 'Visit brand page',
    }),
    contactUs: intl.formatMessage({
      description: 'contact us - T',
      defaultMessage: 'Contact us',
    }),
    addToBookmarks: intl.formatMessage({
      description: 'add to bookmarks - T',
      defaultMessage: 'Add to bookmarks',
    }),
    removeFromBookmarks: intl.formatMessage({
      description: 'remove from bookmarks',
      defaultMessage: 'Remove from bookmarks',
    }),
    categoryPreview: intl.formatMessage({
      description: 'categoryPreview',
      defaultMessage: 'Category',
    }),
    collectionPreview: intl.formatMessage({
      description: 'remove from bookmarks',
      defaultMessage: 'Collection',
    }),
  }),
  brandPage: (intl) => ({
    brandPage: intl.formatMessage({
      description: 'brand page',
      defaultMessage: 'BRAND PAGE',
    }),
    contactUs: intl.formatMessage({
      description: 'contact us',
      defaultMessage: 'Contact us',
    }),
    addToBookmarks: intl.formatMessage({
      description: 'add to bookmarks',
      defaultMessage: 'Add to bookmarks',
    }),
    removeFromBookmarks: intl.formatMessage({
      description: 'remove from bookmarks',
      defaultMessage: 'Remove from bookmarks',
    }),
  }),
  dataSheet: (intl) => ({
    productName: intl.formatMessage({
      description: 'product name',
      defaultMessage: 'Product name',
    }),
    year: intl.formatMessage({
      description: 'year',
      defaultMessage: 'Year',
    }),
    designer: intl.formatMessage({
      description: 'designer',
      defaultMessage: 'Designer',
    }),
    materials: intl.formatMessage({
      description: 'materials',
      defaultMessage: 'Materials',
    }),
    features: intl.formatMessage({
      description: 'features',
      defaultMessage: 'Features',
    }),
    productionProcess: intl.formatMessage({
      description: 'production process',
      defaultMessage: 'Production process',
    }),
    dimensions: intl.formatMessage({
      description: 'dimensions',
      defaultMessage: 'Dimensions',
    }),
    officialWebsiteLink: intl.formatMessage({
      description: 'official website',
      defaultMessage: 'Official website',
    }),
    productSheetLink: intl.formatMessage({
      description: 'product sheet',
      defaultMessage: 'Product sheet',
    }),
    collectionLink: intl.formatMessage({
      description: 'collection',
      defaultMessage: 'Collection',
    }),
    productOverview: intl.formatMessage({
      description: 'product overview',
      defaultMessage: 'Product Overview',
    }),
  }),
  showroom: (intl) => ({
    subtitle: intl.formatMessage({
      description: 'virtual showroom',
      defaultMessage: 'Virtual showroom',
    }),
  }),
  designer: (intl) => ({
    designedBy: intl.formatMessage({
      description: 'designed by',
      defaultMessage: 'Designed by',
    }),
  }),
  TicketsV2: (intl) => getTicketsV2Translations(intl),
  ExhibitorsV2: (intl) => getExhibitorsV2Translations(intl),
  MatchMakingV2: (intl) => getMatchMakingV2Translations(intl),
  DiscountCode: (intl) => getDiscountCodeTranslations(intl),
};

export default translations;
